function st(s) {
  return Array.isArray(s) ? s : s == null ? [] : [s];
}
function pe(s, e) {
  return e = e || document, [...e.querySelectorAll(s)];
}
function l(s, e) {
  return e = e || document, e.querySelector(s) || null;
}
function be(s, e) {
  for (const t of st(s)) e(t);
}
function f(s, e, t, i) {
  be(s, (n) => n.addEventListener(e, t, i));
}
function ze(s, e) {
  f(s, "click", e);
}
function Je() {
  return window.innerWidth <= 968;
}
class ot {
  constructor(e) {
    this.controller = e;
  }
  body = document.createElement("div");
  previousButton = void 0;
  nextButton = void 0;
  render() {
    return this.body.classList.add("advanced-product-option-navigation"), this.body.innerHTML = `
            <button class="button button--filled uppercase button--full previous-button">
                Previous
            </button>
            <button class="button button--filled uppercase button--full next-button">
                Next
            </button>
            `, this.previousButton = l(".previous-button", this.body), this.nextButton = l(".next-button", this.body), f(this.nextButton, "click", () => {
      this.controller.onButtonNext(), this.scrollToFirstElement();
    }), f(this.previousButton, "click", () => {
      this.controller.onPreviousButtonState(), this.scrollToFirstElement();
    }), this.hidePreviousButton(), this.setAddToCartState(), this.body;
  }
  scrollToFirstElement() {
    if (Je()) {
      const e = l(".active-product-option-show");
      e && setTimeout(() => et(e), 100);
    }
  }
  disableButtons() {
    return this.nextButton.setAttribute("disabled", "disabled"), this.nextButton.innerText = "Sold out", this.hidePreviousButton(), this;
  }
  hidePreviousButton() {
    return this.previousButton.style.display = "none", this;
  }
  showPreviousButton() {
    return this.previousButton.style.display = "block", this;
  }
  setAddToCartState() {
    this.nextButton.removeAttribute("disabled");
    const e = this.controller.getCurrentCartButtonHelpText?.();
    this.nextButton.innerText = e || this.controller?.wrappingOption?.config?.add_to_cart_button || "Add to cart";
  }
  setNextStepState() {
    this.nextButton.removeAttribute("disabled");
    const e = this.controller.getCurrentCartButtonHelpText?.();
    this.nextButton.innerText = e || "Next";
  }
  setNextButtonDisabledState() {
    this.nextButton.classList.add("disabled");
  }
  setNextButtonEnabledState() {
    this.nextButton.classList.remove("disabled");
  }
}
class at {
  constructor(e) {
    this.controller = e;
  }
  body = document.createElement("div");
  priceText = void 0;
  otherPriceTags = [];
  price = 0;
  last_calculated_price = 0;
  render() {
    return this.body.classList.add("advanced-product-option-navigation"), this.body.innerHTML = `
            <div class="price price--large price--show-badge">
                <div class="price__container">
                    <div class="price__regular">
                        <span class="price__title">Total</span>
                        <span class="price-item price-item--regular"></span>
                    </div>
                </div>
            </div>
            `, this.priceText = l(".price-item", this.body), this.renderPrice(), this.body;
  }
  setPrice(e) {
    this.price !== e && (this.price = e, this.last_calculated_price = e, this.renderPrice());
  }
  calculatedPrice() {
    let e = this.controller.getAllValidCartOptions().reduce((t, i) => {
      if (i.config?.type === "variant")
        if (i.config.layout === "charm-builder") {
          for (const n of i.getValue()) {
            const a = n.option.price_addon;
            a && parseInt(a) > 0 && (t += +a);
          }
          return t;
        } else {
          const n = i.getValue()?.[0]?.price_addon;
          if (n && parseInt(n) > 0) return t + +n;
        }
      if (i.config?.type === "wrapping")
        for (const n of i.getValue())
          t += +n.price;
      return t;
    }, this.price) || this.price;
    if (this.controller.wrappingOption && this.controller.wrappingOption.getValue()?.[0])
      for (const t of this.controller.wrappingOption.getValue())
        e += +t.price;
    e !== this.last_calculated_price && (this.last_calculated_price = e, this.renderPrice());
  }
  renderPrice() {
    this.priceText && (this.priceText.innerHTML = `£${this.last_calculated_price.toFixed(2)} GBP`);
    for (const e of this.otherPriceTags) {
      const t = e();
      t && (t.innerHTML = `£${this.last_calculated_price.toFixed(2)}`);
    }
  }
  setOtherPriceTagElement(e) {
    e && this.otherPriceTags.push(e);
  }
}
class ne {
  constructor(e, t, i) {
    this.controller = e, t && this.setConfig(t), i && this.setType(i), this.body = document.createElement("div"), this.body.classList.add("advanced-product-option");
  }
  type;
  config;
  section = 0;
  visible = !1;
  been_shown = !1;
  rendered = !1;
  values = [];
  body;
  setType(e) {
    return this.type = e, this;
  }
  setSection(e) {
    return this.section = e, this;
  }
  getSection() {
    return this.section;
  }
  setConfig(e) {
    return this.config = e, this;
  }
  setValue(e) {
    if (this.values = Array.isArray(e) ? e : [e], e && this.hideError(), e?.product_image) {
      const t = l(".product__media.media img");
      t && (t.setAttribute("srcset", ""), t.src = e.product_image);
    }
    this.controller.processValueUpdate();
  }
  getValue() {
    return this.values;
  }
  resetValue() {
    return this.values = [], this;
  }
  performHide() {
    this.body.classList.remove("active-product-option-show"), this.visible = !1;
  }
  performShow() {
    this.body.classList.add("active-product-option-show"), this.visible = !0, this.been_shown = !0;
  }
  isVisible() {
    return this.visible;
  }
  performRender() {
    if (!this.rendered) {
      const e = this.render();
      this.addErrorElement(e), this.controller.getTarget().appendChild(e), this.rendered = !0;
    }
    return this;
  }
  hideError() {
    this.body.classList.remove("error");
  }
  showError() {
    this.body.classList.add("error");
  }
  addErrorElement(e) {
    const t = document.createElement("div");
    t.classList.add("advanced-product-option-error-message"), t.innerHTML = '<span class="advanced-product-option-error-message-text">Please select a valid option</span>', e.appendChild(t);
  }
  hasBeenShown() {
    return this.been_shown;
  }
  validate() {
    return !0;
  }
}
function Ge() {
  return `
    <div class="ivet_close_btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
        </svg>
    </div>`;
}
function rt(s, e, t) {
  return `
    <div class="ivet_image">
        <div class="ivet_image-container">
            <img src="${s}" alt="front"/>
                 <canvas width="${e}" height="${t}"></canvas>
            </div>
    </div>
    `;
}
function lt(s) {
  return s.length < 2 ? "" : `
        <div class="ivet_section_indicator">
                <ul>${s.map(
    (t, i) => `<li><a href="#" class="${i === 0 ? "current" : ""}" data-section="${i}">${t.title}</a></li>`
  ).join(`
`)}</ul>
        </div>
    `;
}
function ct(s) {
  return `    
      <div class="ivet_title">
        <span>${s}</span>
     </div>`;
}
function dt(s, e, t) {
  let i = `<div class="ivet_control" data-field-type="text" data-section-id="${e}" data-field-key="${t}">`;
  s.title && (i += `<div class="ivet_control-title">${s.title}</div>
`), s.help_text && (i += `<div class="ivet_control-label">${s.help_text}</div>
`);
  const n = ["ivet_control-input"];
  return s.singleLine && n.push("is-single-line"), i += '<div class="' + n.join(" ") + '">', i += `<div class="ivet_control-input-characters-left"><span>${s.validation.maxLength} character${(s.validation.maxLength || 1) > 1 ? "s" : ""} left</span></div>`, i += `<textarea>${s.defaultValue || ""}</textarea>`, i += `<div class="ivet_control-input-error">Please enter ${s.validation.minLength || 1} or more characters</div>`, i += `<div class="ivet_control-input-overflow-error">Character limit reached (${s.validation.maxLength} character${(s.validation.maxLength || 0) === 1 ? "" : "s"})</div>`, i += '<div class="ivet_control-floating-row">', (s.minFontSize && s.minFontSize < s.fontSize || s.maxFontSize && s.maxFontSize > s.fontSize) && (i += pt(s.fontSize, s.minFontSize || s.fontSize, s.maxFontSize || s.fontSize)), i += "</div>", i += "</div>", i += ht(s.fonts), i += "</div>", i;
}
function ht(s) {
  return s.length <= 1 ? "" : `
    <div class="ivet_fontfamily">${s.map((t, i) => `
    <div class="ivet_fontfamily_opt ${i === 0 ? "ivet_fontfamily_opt-current" : ""}" data-fontfamily="${t.font}">
    <span style="font-family: ${t.font};" data-default-font-label="${t.label}">${t.label}</span></div>
    `).join(`
`)}</div>
    `;
}
function pt(s, e, t) {
  return `
       <div class="ivet_fontsize" data-min="${e}" data-max="${t}" data-value="${s}">
           <span class="ivet_fs_min">-</span>
           <span class="ivet_fs_indicator">
                <span>A</span>
                <span>A</span>
                <span>A</span>
            </span>
           <span class="ivet_fs_max">+</span>
       </div>
    `;
}
function ut(s) {
  const e = [];
  for (const t in s)
    for (const i in s[t].fields) {
      const n = s[t].fields[i];
      n.type === "text" && e.push(dt(n, +t, +i)), n.type === "image" && e.push(ft(n, +t, +i));
    }
  return e.join(`
`);
}
function ft(s, e, t) {
  return `
        <div class="ivet_control" data-field-type="image" data-section-id="${e}" data-field-key="${t}">
            ${s.title ? `<div class="ivet_control-title">${s.title}</div>` : ""}
            ${s.help_text ? `<div class="ivet_control-label">${s.help_text}</div>` : ""}
            <div class="ivet_control-input">
                <div class="ivet_image_preview">
                    <div class="ivet_image_preview_draggable">Click to select a image</div>
                    <div class="ivet_image_preview_draggable_box" style="display: none">&nbsp;</div>
                </div>
                <div class="ivet_image_controls" style="display: none">
                    <div class="ivet_image_size_control" style="display: none">
                        <span>Size</span>
                        <input type="range" class="ivet_image_size" min="10" max="300" value="100" />
                    </div>
                </div>
                <div class="ivet_control-input-error">Please select a file to upload</div>
              <input type="file" accept="image/*" class="ivet_image_upload" style="display:none" />
              <button class="ivet_image_upload_button">Change image</button>
            </div>
        </div>
    `;
}
function mt(s, e = 0) {
  return `
        <div class="improved-variants-engraving-tool">
            <div class="ivet_container">
                ${Ge()}
                ${rt(s.sections[e].img, s.sections[e].canvas.width, s.sections[e].canvas.height)}
                <div class="ivet_controls">
                    <div class="ivet_control_items">
                    ${ct(s.title)}
                    <div class="ivet_control_navigation">
                     ${lt(s.sections)}
                        <div class="ivet_control_reset_button">
                            <button class="ivet_control_reset_button-button">
                                Reset fields
                            </button>
                        </div>
                    </div>
                    ${ut(s.sections)}
                    </div>
                </div>
            </div>
        </div>
    `;
}
class gt {
  canvas;
  context;
  drawer;
  width = 0;
  height = 0;
  constructor(e) {
    this.context = new bt(this), this.drawer = new vt(this), e && this.setCanvas(e);
  }
  setCanvas(e) {
    return this.canvas = e, this.width = e.width, this.height = e.height, this;
  }
  getCanvas() {
    return this.canvas;
  }
  getCanvasScale() {
    return this.canvas ? this.canvas.width / this.canvas.offsetWidth : 0;
  }
  draw() {
    return this.drawer.draw(), this;
  }
  addDrawable(e) {
    return this.drawer.add(e), this;
  }
}
class vt {
  constructor(e) {
    this.manager = e;
  }
  drawItems = [];
  draw(e, t, i, n) {
    e && t && i && n ? this.manager.context.getContext()?.clearRect(e, t, i, n) : this.manager.context.getContext()?.clearRect(0, 0, this.manager.width, this.manager.height);
    for (const a of this.drawItems)
      a.draw(
        this.manager.context.getFreshContext(),
        this.manager
      );
  }
  getItems() {
    return this.drawItems;
  }
  add(e) {
    return this.drawItems.push(e), this;
  }
  remove(e) {
    return this.drawItems = this.drawItems.filter((t) => t !== e), this;
  }
  removeAll() {
    return this.drawItems = [], this;
  }
}
const _t = [
  "direction",
  "fillStyle",
  "filter",
  "font",
  "fontKerning",
  "fontStretch",
  "fontVariantCaps",
  "globalAlpha",
  "globalCompositeOperation",
  "imageSmoothingEnabled",
  "imageSmoothingQuality",
  "letterSpacing",
  "lineCap",
  "lineDashOffset",
  "lineJoin",
  "lineWidth",
  "miterLimit",
  "shadowBlur",
  "shadowColor",
  "shadowOffsetX",
  "shadowOffsetY",
  "strokeStyle",
  "textAlign",
  "textBaseline",
  "textRendering",
  "wordSpacing"
];
class bt {
  constructor(e) {
    this.manager = e;
  }
  defaultStyles = {};
  styles = {};
  context;
  setStyles(e) {
    for (const t in e)
      this.styles[t] = e[t], this.getContext() && (this.getContext()[t] = e[t]);
  }
  getContext() {
    return !this.context && this.manager?.getCanvas() && (this.context = this.manager?.getCanvas()?.getContext("2d"), this.storeDefaultConfig()), this.context;
  }
  getFreshContext() {
    return this.resetStyles(), this.getContext();
  }
  storeDefaultConfig() {
    const e = this.manager?.getCanvas();
    if (this.getContext().reset(), e) for (const t of _t) this.defaultStyles[t] = this.getContext()[t];
    return this;
  }
  resetStyles() {
    for (const e in this.styles)
      this.getContext() && (this.context[e] = this.defaultStyles[e]), Reflect.deleteProperty(this.styles, e);
  }
}
class Ke {
  x_s = 0;
  x_e = 0;
  y_s = 0;
  y_e = 0;
  width = 0;
  height = 0;
  should_draw = !0;
  events = {};
  state = "idle";
  setState(e) {
    return this.state = e, this;
  }
  getState() {
    return this.state;
  }
  addEvent(e, t) {
    return this.events[e] || (this.events[e] = []), this.events[e].push(t), this;
  }
  hasEvents(e) {
    return this.events?.[e] && this.events[e].length;
  }
  removeEvent(e, t) {
    return this.events[e] ? (this.events[e] = this.events[e].filter((i) => i !== t), this) : this;
  }
  triggerEvent(e, ...t) {
    if (!this.events[e]) return this;
    for (const i of this.events[e])
      i(...t);
    return this;
  }
  setWidth(e) {
    return this.width = e, this;
  }
  setHeight(e) {
    return this.height = e, this;
  }
  x(e) {
    return e ? this.x_s = e : this.x_s;
  }
  xEnd(e) {
    return e ? this.x_e = e : this.x_e;
  }
  y(e) {
    return e ? this.y_s = e : this.y_s;
  }
  setShouldDraw(e) {
    return this.should_draw = e, this;
  }
  shouldDraw() {
    return typeof this.should_draw == "function" ? this.should_draw() : this.should_draw;
  }
  yEnd(e) {
    return e ? this.y_e = e : this.y_e;
  }
  setRectBounds(e, t, i, n) {
    return this.x_s = e, this.x_e = e + i, this.y_s = t, this.y_e = t + n, this;
  }
  isInMyBounds(e, t) {
    if (!(e >= this.x_s && e <= this.x_e && t >= this.y_s && t <= this.y_e)) return !1;
    const n = 10;
    let a = { action: "move", direction: "none" };
    return e >= this.x_s && e <= this.x_s + n && (a = { action: "resize", direction: "left" }), e <= this.x_e && e >= this.x_e - n && (a = { action: "resize", direction: "right" }), t >= this.y_s && t <= this.y_s + n && (a = { action: "resize", direction: "top" }), t <= this.y_e && t >= this.y_e - n && (a = { action: "resize", direction: "bottom" }), a;
  }
  canFitBounds(e, t, i, n, a) {
    const o = e.getCanvas();
    if (!o) return !1;
    const p = o.width, h = o.height;
    n = n ?? this.width, a = a ?? this.height;
    const m = t + n, T = i + a;
    return t >= 0 && i >= 0 && m <= p && T <= h;
  }
  draw(e, t) {
    this.shouldDraw() && (this.onDraw(e, t), this.setRectBounds(this.x_s, this.y_s, this.width, this.height));
  }
}
class yt extends Ke {
  #i = 100;
  #s = "sans-serif";
  #o = "Enter text here";
  #n = "#000";
  #t = "center";
  #e = "center";
  size(e) {
    return e ? this.#i = e : this.#i;
  }
  color(e) {
    return e ? this.#n = e : this.#n;
  }
  position(e) {
    return e ? this.#t = e : this.#t;
  }
  alignment(e) {
    return e ? this.#e = e : this.#e;
  }
  renderedSize() {
    return Math.min(700, this.#i);
  }
  fontFamily(e) {
    return e ? this.#s = e + ", sans-serif" : this.#s;
  }
  text(e) {
    return e !== void 0 ? this.#o = e : this.#o;
  }
  setTextStyles(e) {
    e.context.setStyles({
      font: `${this.renderedSize()}px ${this.fontFamily()}`,
      textAlign: this.#e,
      fillStyle: this.#n
    });
  }
  onDraw(e, t) {
    this.setTextStyles(t);
    const i = this.text().split(`
`);
    let n = (this.height - this.renderedSize() * i.length) / 2;
    this.#t === "top" && (n = 0), this.#t === "bottom" && (n = this.height - this.renderedSize() * i.length);
    let a = this.width / 2;
    this.#e === "left" && (a = 0), this.#e === "right" && (a = this.width);
    let o = 0;
    for (const p of i)
      o++, e.fillText(p, this.x() + a, n + this.y() + this.renderedSize() * o, this.width);
  }
}
class We extends Ke {
  image;
  scale = 1;
  offsetX = 0;
  offsetY = 0;
  leftDifference = 0;
  topDifference = 0;
  loaded_image = !1;
  full_width = !1;
  setImage(e) {
    return this.image = new Image(), this.loaded_image = !1, this.image.src = e, this.image.setAttribute("crossorigin", "anonymous"), this.offsetX = 0, this.offsetY = 0, this.scale = 1, this;
  }
  setScale(e) {
    return this.scale = e / 100, this;
  }
  getScale() {
    return this.scale;
  }
  setOffset(e, t) {
    return this.offsetX = e, this.offsetY = t, this;
  }
  onDraw(e) {
    if (this.image) {
      const t = () => {
        let i = this.width / this.scale, n = this.height / this.scale;
        const a = this.offsetX - this.leftDifference, o = this.offsetY - this.topDifference;
        this.full_width ? e.drawImage(
          this.image,
          a,
          o,
          i,
          n
        ) : e.drawImage(
          this.image,
          a,
          o,
          i,
          n,
          this.x(),
          this.y(),
          this.width,
          this.height
        );
      };
      !this.loaded_image && !this.image.complete ? this.image.onload = () => {
        this.loaded_image = !0, t();
      } : (this.loaded_image = !0, t());
    }
  }
}
class wt extends We {
  onDraw(e) {
    if (this.image) {
      const t = () => {
        e.save(), e.beginPath(), e.arc(this.x() + this.width / 2, this.y() + this.height / 2, this.width / 2, 0, 2 * Math.PI), e.closePath(), e.clip();
        let i = this.width / this.scale, n = this.height / this.scale;
        const a = this.offsetX - this.leftDifference, o = this.offsetY - this.topDifference;
        this.full_width ? e.drawImage(
          this.image,
          a,
          o,
          i,
          n
        ) : e.drawImage(
          this.image,
          a,
          o,
          i,
          n,
          this.x(),
          this.y(),
          this.width,
          this.height
        ), e.restore();
      };
      !this.loaded_image && !this.image.complete ? this.image.onload = () => {
        this.loaded_image = !0, t();
      } : (this.loaded_image = !0, t());
    }
  }
}
function xt(s, e, t = null, i = null) {
  const n = document.createElement("div");
  n.className = "engraving-preview-container", be(l(".engraving-preview-container", s.parentElement), (a) => s.parentElement.removeChild(a)), e.sections.forEach((a, o) => {
    const p = document.createElement("div");
    p.className = "engraving-preview-item", p.innerHTML = `
        <div class="engraving-preview-item-title">
            ${a.title}
        </div>
        `;
    const h = document.createElement("img");
    h.src = t?.sectionImages?.[o] || a.img, p.appendChild(h), p.addEventListener("click", () => {
      Ne(e, s, i, o), Qe(s, o);
    }), n.appendChild(p);
  }), s.parentElement?.insertBefore(n, s), s.innerText = "Edit engraving";
}
function Lt(s, e, t, i) {
  const n = l(".ivet_control_reset_button", s), a = l(".ivet_control_reset_button-button", s), o = () => n.style.display = "none", p = () => n.style.display = "flex", h = (T) => {
    for (const [g, w] of Object.entries(e.filter((v) => v.section === T))) {
      if (t.sections[T].fields[g].type === "text")
        w.value.text = "", l("textarea", w.field).value = "", l("textarea", w.field).dispatchEvent(new Event("change")), w.drawItem.text("");
      else {
        w.value.imageData = null;
        const P = l("img", w.field);
        P && P.parentElement.removeChild(P), l(".ivet_image_preview_draggable_box", w.field).style.display = "none", l(".ivet_image_preview_draggable", w.field).innerText = "Click to select a image", l(".ivet_image_upload_button", w.field).style.display = "none", w.drawItem.image = void 0;
      }
      i.draw();
    }
    m();
  }, m = (T) => {
    p();
  };
  return {
    button: a,
    buttonContainer: n,
    resetCurrentFields: h,
    hideContainer: o,
    showContainer: p,
    toggleShowHide: m
  };
}
function Ne(s, e, t = null, i = 0) {
  const n = document.createElement("div");
  n.innerHTML = mt(s, i);
  const a = n.firstElementChild;
  document.body.appendChild(a);
  let o = new gt(l("canvas", a));
  const p = l(".ivet_image", a), h = l(".ivet_image-container", a), m = JSON.parse(e.dataset.engravingState || "{}");
  let T = 0;
  const g = [], w = pe(".ivet_control", a), v = Lt(a, g, s, o);
  f(v.button, "click", () => {
    v.resetCurrentFields(i);
  });
  const P = (u, L) => {
    T = u, A(L);
  }, x = [], F = [], W = () => F.map((u) => u.hide()), D = (u) => F.filter((L) => L.section === u).map((L) => L.show());
  for (const u in s.sections) {
    const L = s.sections[u], y = new We();
    y.full_width = !0, y.setImage(L.img), y.setWidth(L.canvas.width), y.setHeight(L.canvas.height), y.x(0), y.y(0), y.setShouldDraw(() => i === +u), o.addDrawable(y);
  }
  for (const u of w) {
    const L = +u.dataset.fieldKey, y = +u.dataset.sectionId, N = u.dataset.fieldType;
    if (N === "text") {
      const E = s.sections[y].fields[L], S = l("textarea", u), me = l(".ivet_control input[type=range]", u), R = l(".ivet_control_emoji_trigger-clicker", u), z = l(".ivet_control-input-characters-left span", u), oe = l(".ivet_control-input-overflow-error", u), $ = l(".ivet_fontsize", u)?.dataset, ee = $?.max || 0, ke = $?.min || 0;
      let q = $?.value || 0;
      const C = new yt(), te = {
        section: y,
        key: L,
        drawItem: C,
        field: u,
        value: {
          text: E.defaultValue,
          fontSize: E.fontSize,
          fontFamily: E.fonts[0].font
        }
      };
      if (o.addDrawable(C), C.setShouldDraw(() => i === y), C.setWidth(E.canvas.width), C.setHeight(E.canvas.height), C.x(E.canvas.left), C.y(E.canvas.top), C.size(E.fontSize), C.fontFamily(E.fonts[0].font), C.color(E.color), C.alignment(E.alignment), C.position(E.position), !E.defaultValue && E.placeholder) {
        let r = function() {
          S.value === E.placeholder && (S.value = ""), S.dispatchEvent(new Event("change")), S.removeEventListener("click", r);
        };
        C.text(E.placeholder), S.value = E.placeholder, S.addEventListener("click", r), setTimeout(() => o.draw(), 100);
      } else
        C.text(E.defaultValue);
      let j = S.value, U = S.value;
      const Q = () => {
        z.innerHTML = E.validation.maxLength - S.value.length + " characters left";
      }, J = (r, d) => `${r} ${d}${r === 1 ? "" : "s"}`, V = {
        maxWordsPerLine: `Word limit reached (${J(E.validation.maxWordsPerLine, "word")})`,
        maxLines: `Maximum lines reached (${J(E.validation.maxLines, "line")})`,
        maxLength: `Character limit reached (${J(E.validation.maxLength, "character")})`
      }, re = (r, d) => {
        oe && (r && d && (oe.innerText = V[d]), oe.style.display = r ? "block" : "none");
      };
      let K = null;
      const De = () => {
        K !== null && (clearTimeout(K), K = null), re(!1);
      }, ge = (r) => {
        re(!0, r), K !== null && clearTimeout(K), K = setTimeout(() => {
          K = null, re(!1);
        }, 5e3);
      }, ye = (r) => {
        be(pe("[data-default-font-label]", u), (d) => {
          d.innerText = r ? `${r.slice(0, 12)}${r.length > 12 ? "..." : ""}` : d.dataset.defaultFontLabel;
        });
      }, le = () => {
        if (S.value === U) return;
        U = S.value;
        let r = S.value;
        const d = C.width;
        o.context.getFreshContext(), C.setTextStyles(o);
        const c = o.context.getContext(), b = (B) => {
          if (c.measureText(B).width <= d) return [B];
          const O = B.split(" "), Z = [];
          let X = "";
          for (const ie of O) {
            const de = X ? `${X} ${ie}` : ie;
            c.measureText(de).width > d && X ? (Z.push(X), X = ie) : X = de;
          }
          return X && Z.push(X), Z;
        };
        r = r.split(`
`).flatMap(b).join(`
`), o.context.getFreshContext();
        const { text: _, overflowed: M, reason: I } = St(
          r,
          E.validation
        );
        if (M) {
          S.value = j, U = j, S.selectionStart = S.selectionEnd = j.length, ge(I), Q();
          return;
        }
        De(), j = _, _ !== S.value && (S.value = _, U = _), C.text(_.trim() || ""), te.value.text = _, o.draw(), Q(), ye(_.trim()), v.toggleShowHide(i);
      }, Pe = (r) => {
        C.size(r), te.value.fontSize = r, o.draw();
      }, Ve = (r) => {
        C.fontFamily(r), te.value.fontFamily = r, o.draw();
      };
      if (R) {
        const r = Math.round(Math.random() * 1e8), d = "ivet_emoji_popup_selector_" + r, c = "ivet_emoji_popup_dest_" + r;
        S.classList.add(c), R.classList.add(d);
      }
      f(S, "keyup", le), f(S, "change", le), f(S, "paste", le), f(S, "input", le), f(S, "paste", le), f(u, "focusin", () => P(L, E)), f(u, "click", () => P(L, E)), me && f(me, "change", () => Pe(+q));
      const ce = l(".ivet_fs_min", u), we = l(".ivet_fs_max", u), xe = () => {
        Pe(+q), Me();
      }, Me = () => {
        ce?.classList[q <= ke ? "add" : "remove"]("disabled"), we?.classList[q >= ee ? "add" : "remove"]("disabled");
      };
      ze(ce, () => {
        +q - 1 >= +ke && (q = +q - 1 + "", xe());
      }), ze(we, () => {
        +q + 1 <= +ee && (q = +q + 1 + "", xe());
      }), ze(pe(".ivet_fontfamily_opt", u), (r) => {
        const d = "ivet_fontfamily_opt-current";
        let c = r.target;
        c.tagName !== "DIV" && (c = c.parentElement);
        for (const b of c.parentElement.children)
          b === c ? b.classList.add(d) : b.classList.remove(d);
        Ve(c.dataset.fontfamily);
      }), g.push(te);
    }
    if (N === "image") {
      let E = function(r, d, c, b, _) {
        const M = r.parentElement.getBoundingClientRect(), I = l("img", d);
        if (!I || !I.complete) {
          setTimeout(() => E(r, d, c, b, _), 100);
          return;
        }
        const B = I.naturalWidth / I.width, O = b.canvas.width / I.naturalWidth * 100;
        c.setScale(O), _.value.scale = O;
        const Z = b.canvas.width * (I.width / I.naturalWidth) / (O / 100), X = b.canvas.height * (I.height / I.naturalHeight) / (O / 100), ie = (M.width - Z) / 2, de = (M.height - X) / 2;
        r.style.width = Z + "px", r.style.height = X + "px", r.style.transform = `translate(${ie}px, ${de}px)`;
        const Ie = ie * B, he = de * B;
        c.setOffset(Ie, he), _.value.offset.x = Ie, _.value.offset.y = he, o.draw(), r.style.display = "block";
      }, S = function(r = !1, d = !1) {
        ke();
        const c = l("img", C);
        !c || !c.complete ? setTimeout(() => S(r), 100) : ((!re || r) && ((!Object.keys(m).length || d) && E($, $.parentElement, k, z, V), o.draw(), re = !0), K(c), v.toggleShowHide(i));
      }, me = function(r) {
        const d = ge(r), c = $?.getBoundingClientRect(), b = j - d.x, _ = U - d.y, M = {
          top: c.top - _,
          bottom: c.bottom - _,
          left: c.left - b,
          right: c.right - b
        };
        if (ye(M)) return !0;
        const B = l("img", C).getBoundingClientRect();
        return b > 0 && M.left >= B.left || b < 0 && M.right <= B.right ? (U = d.y, !0) : _ > 0 && M.top >= B.top || _ < 0 && M.bottom <= B.bottom ? (j = d.x, !0) : !1;
      }, R = function(r) {
        const d = ge(r), c = u.getBoundingClientRect(), b = d.x >= c.left && d.x <= c.right && d.y >= c.top && d.y <= c.bottom;
        if (r.preventDefault(), r.stopPropagation(), Q && b) {
          const _ = l("img", C), M = _.naturalWidth / _.width;
          if (J && J !== "move") {
            let I = d.x - j, B = d.y - U, O = 0;
            J === "right" ? O = -I : J === "left" ? O = I : J === "bottom" ? O = -B : J === "top" && (O = B), O *= 0.85;
            const Z = V.value.scale, X = V.value.scale + O, ie = V.drawItem.width, de = ie / (Z / 100), Ie = ie / (X / 100), he = (de - Ie) / 2;
            V.value.scale;
            const $e = V.value.scale + O;
            j = d.x, U = d.y;
            const ve = De($e);
            ve.top += he, ve.left += he;
            const Xe = !ye(ve) && le(ve);
            if (ye(ve) || Xe) {
              let He = k.offsetX + he, Re = k.offsetY + he;
              if (Xe) {
                const _e = Pe({ ...ve });
                _e.left && (_e.xFrom === "left" ? He = k.leftDifference : He += -(_e.left * M)), _e.top && (_e.yFrom === "top" ? Re = k.topDifference : Re += -(_e.top * M));
              }
              k.setOffset(He, Re), te.value = $e.toString(), k.setScale($e), V.value.scale = $e, o.draw(), S();
            }
          } else {
            if (!_) return;
            if (!me(r)) {
              j = d.x, U = d.y;
              return;
            }
            k.leftDifference = (_.parentElement.offsetWidth - _.offsetWidth) * M / 2, k.topDifference = (_.parentElement.offsetHeight - _.offsetHeight) * M / 2;
            const I = d.x - j, B = d.y - U, O = k.offsetX + I * M, Z = k.offsetY + B * M;
            j = d.x, U = d.y, k.setOffset(O, Z), o.draw(), S(), V.value.offset.x = k.offsetX, V.value.offset.y = k.offsetY, r.stopPropagation(), r.preventDefault();
          }
        } else
          Ve();
      };
      const z = s.sections[y].fields[L], oe = l("input[type=file]", u), k = z.is_rounded ? new wt() : new We(), $ = l(".ivet_image_preview_draggable_box", u);
      F.push({
        el: $,
        hide: () => $.style.display = "none",
        show: () => $.parentElement.querySelector("img") ? $.style.display = "block" : "",
        section: y
      });
      const ee = l(".ivet_image_upload_button", u);
      ee.style.display = "none", f(ee, "click", () => {
        oe.click();
      });
      const ke = () => {
        ee.style.display !== "block" && l(".ivet_image_preview_draggable img", u) && (ee.style.display = "block", setTimeout(() => ee.style.opacity = "1", 100));
      }, q = m?.fields?.find((r) => r.section === y && r.key === L) || {}, C = l(".ivet_image_preview_draggable", u), te = l(".ivet_image_size", u);
      let j = 0, U = 0, Q = !1, J = !1;
      const V = {
        section: y,
        key: L,
        drawItem: k,
        field: u,
        value: {
          imageData: q?.value?.imageData || null,
          scale: q?.value?.scale || 100,
          offset: {
            x: q?.value?.offset.x || 0,
            y: q?.value?.offset.y || 0
          }
        }
      };
      f(C, "click", () => ee.style.display === "none" && oe.click()), f(u, "focusin", () => P(L, z)), f(u, "click", () => P(L, z)), V.value?.imageData && (k.setImage(V.value.imageData), be(pe(".ivet_image_preview_draggable_box, .ivet_image_size_control", u), (r) => r.style.display = "block"), S(!0)), k.setScale(V.value.scale), k.setOffset(V.value.offset.x, V.value.offset.y), k.setShouldDraw(() => i === y).setWidth(z.canvas.width).setHeight(z.canvas.height), k.x(z.canvas.left), k.y(z.canvas.top), o.addDrawable(k);
      let re = !1;
      const K = (r, d = 0) => {
        const c = r ?? l("img", C);
        if (!c || !c.complete) {
          if (d > 20) return;
          setTimeout(() => K(r, ++d), 20);
          return;
        }
        const b = c.width / c.naturalWidth, _ = c.naturalWidth / c.width, M = z.canvas.width * b / k.getScale(), I = z.canvas.height * b / k.getScale(), B = (c.parentElement.offsetWidth - c.offsetWidth) * _ / 2, O = (c.parentElement.offsetHeight - c.offsetHeight) * _ * k.getScale() / 2;
        k.leftDifference = B, k.topDifference = O, $.style.width = M + "px", $.style.height = I + "px", $.style.transform = `translate(${k.offsetX / _}px, ${k.offsetY / _}px)`, o.draw();
      };
      x.push(K);
      const De = (r) => {
        const d = l("img", C);
        r = r / 100;
        const c = $.parentElement.getBoundingClientRect(), b = d.width / d.naturalWidth, _ = d.naturalWidth / d.width, M = z.canvas.width * b / r, I = z.canvas.height * b / r, B = c.top + k.offsetY / _, O = c.left + k.offsetX / _;
        return {
          width: M,
          height: I,
          top: B,
          left: O,
          bottom: B + I,
          right: O + M
        };
      }, ge = (r) => r instanceof MouseEvent ? { x: r.clientX, y: r.clientY } : { x: r.touches[0].clientX, y: r.touches[0].clientY }, ye = (r) => {
        const c = l("img", C).getBoundingClientRect();
        return Math.round(r.top + 2) >= Math.round(c.top) && Math.round(r.bottom + 2) <= Math.round(c.bottom) && Math.round(r.left - 2) >= Math.round(c.left) && Math.round(r.right + 2) <= Math.round(c.right);
      }, le = (r) => {
        const c = l("img", C).getBoundingClientRect();
        return r.width <= c.width && r.height <= c.height;
      }, Pe = (r) => {
        const c = l("img", C).getBoundingClientRect();
        let b = 0, _ = 0, M = "", I = "";
        return r.top + 2 < c.top ? (b = Math.round(r.top - c.top), I = "top") : r.bottom > c.bottom && (b = Math.round(r.bottom - c.bottom), I = "bottom"), r.left + 2 < c.left ? (_ = Math.round(r.left - c.left), M = "left") : r.right > c.right && (_ = Math.round(r.right - c.right), M = "right"), { top: b, left: _, xFrom: M, yFrom: I };
      }, Ve = () => {
        j = 0, U = 0, window.removeEventListener("mousemove", R), window.removeEventListener("touchstart", R), Q = !1;
      }, ce = (r) => {
        if (Q) return;
        const d = we(r);
        if (!d) return;
        const c = ge(r);
        j = c.x || r.clientX, U = c.y || r.clientY, Q = !0, J = d, window.addEventListener("mousemove", R), window.addEventListener("touchstart", R), window.addEventListener("touchmove", R), r.preventDefault(), r.stopPropagation();
      }, we = (r) => {
        const d = ge(r), c = $?.getBoundingClientRect(), b = 20;
        return d.y >= c.top - b && d.y <= c.top + b ? "top" : d.y <= c.bottom + b && d.y >= c.bottom - b ? "bottom" : d.x >= c.left - b && d.x <= c.left + b ? "left" : d.x <= c.right + b && d.x >= c.right - b ? "right" : d.y >= c.top && d.y <= c.bottom && d.x >= c.left && d.x <= c.right ? "move" : !1;
      }, xe = (r) => {
        switch (r) {
          case "top":
            return "n-resize";
          case "bottom":
            return "s-resize";
          case "left":
            return "w-resize";
          case "right":
            return "e-resize";
          case "move":
            return "move";
          default:
            return "initial";
        }
      }, Me = (r) => {
        if (Q) return;
        const d = we(r);
        J = d, C.style.cursor = xe(d), $.style.cursor = xe(d);
      };
      f($, "mousedown", ce), f($, "touchstart", ce), f($, "touchmove", R), f($, "mousemove", Me), f(C, "mousemove", Me), f(C, "mousedown", ce), f(C, "touchstart", ce), f(C, "touchmove", R), f(window, "mouseup", () => {
        Q = !1, window.removeEventListener("mousemove", R);
      }), f(window, "touchend", () => {
        Q = !1, window.removeEventListener("touchstart", R);
      }), f(window, "resize", () => S()), f(oe, "change", (r) => {
        const d = oe.files?.[0];
        if (d) {
          const c = new FileReader();
          c.onload = (b) => {
            const _ = document.createElement("img");
            _.src = b.target?.result, _.draggable = !1, C.innerHTML = "", C.appendChild(_), re = !1, $.style.display = "none", setTimeout(() => S(!0, !0), 100), k.setImage(b.target?.result), V.value.imageData = b.target?.result, o.draw(), be(pe(".ivet_image_preview_draggable_box, .ivet_image_size_control", u), (M) => M.style.display = "block");
          }, c.readAsDataURL(d);
        }
      }), f(te, "input", () => {
        k.setScale(+te.value), V.value.scale = +te.value, S(), o.draw();
      }), g.push(V);
    }
  }
  const H = (u) => {
    for (const L of g) {
      const y = L.section !== u;
      L.field.style.setProperty("display", y ? "none" : "block");
    }
    W(), v.toggleShowHide(u), setTimeout(() => {
      Fe(), A(s.sections[u].fields[0]), D(u);
    }, 100);
  }, A = (u) => {
    const L = h?.offsetHeight || 0, y = p?.offsetHeight || 0, N = u.canvas.top, E = o.getCanvas().height, me = o.getCanvas().offsetHeight / E;
    let R = Math.round(N * me - y / 2);
    const z = Math.max(0, L - y);
    R = Math.min(Math.max(R, 0), z), h.style.transform = `translate(0, -${R}px)`;
  }, Y = () => {
    let u = !1;
    for (const [L, y] of Object.entries(g.filter((N) => N.section === i))) {
      const N = s.sections[i].fields[L];
      N.type === "text" ? N.validation.required && (y.value.text || "").length < (N.validation.minLength || 1) ? (u = !0, y.field.classList.add("error")) : y.field.classList.remove("error") : N.validation.required && !y.value.imageData ? (u = !0, y.field.classList.add("error")) : y.field.classList.remove("error");
    }
    return !u;
  }, G = () => {
    const u = document.querySelector(".ivet_control.error");
    u && u.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  }, Be = pe(".ivet_section_indicator ul li a", a);
  f(Be, "click", (u) => {
    const L = u.target, y = +L.dataset.section;
    if (s.sections[y]) {
      if (ae(), y > i && !Y()) {
        G();
        return;
      }
      l(".ivet_control_items", a)?.scrollTo(0, 0);
      const E = L.parentElement.parentElement;
      for (const S of E.children)
        S.firstElementChild === L ? S.firstElementChild.classList.add("current") : S.firstElementChild.classList.remove("current");
      i = y, H(y), Ae(), o.getCanvas().width = s.sections[y].canvas.width, o.getCanvas().height = s.sections[y].canvas.height, o.draw();
    }
  });
  const Se = () => {
    a.classList.add("close"), setTimeout(() => {
      a.remove();
    }, 1e3), o = null, g.length = 0, document.body.style.overflow = "";
  }, Ce = l(".ivet_close_btn", a);
  f(Ce, "click", Se);
  const Ee = l(".ivet_controls", a), se = document.createElement("button"), Te = () => i === s.sections.length - 1, Oe = () => Te() ? "Confirm" : "Next", Ae = () => se.textContent = Oe();
  se.className = "ivet_add_to_bag product-form__submit button button--filled uppercase button--full", se.textContent = Oe(), Ee.appendChild(se);
  const ue = [], ae = () => {
    o.draw(), ue[i] = o.getCanvas().toDataURL();
  };
  f(se, "click", () => {
    if (Te())
      if (Y()) {
        ae();
        const u = {
          currentSection: i,
          fields: g.map((L) => ({
            section: L.section,
            key: L.key,
            value: L.value
          })),
          sectionImages: ue
        };
        typeof t == "function" && t(u), xt(e, s, u, t), e.dataset.engravingState = JSON.stringify(u), Se();
      } else
        G();
    else
      ae(), l(`[data-section="${i + 1}"]`, se.parentElement.parentElement)?.click(), Ae(), Ee?.scrollTo({ top: 0, behavior: "smooth" });
  });
  const Fe = () => {
    x.length && x.forEach((u) => u());
  };
  H(i), document.body.style.overflow = "hidden", Object.keys(m).length && setTimeout(() => H(i), 300);
  const fe = () => {
    const u = Ce?.getBoundingClientRect().bottom, L = v.button?.getBoundingClientRect().top, y = u >= L;
    v.button.style.marginRight = y ? "2em" : "", be(l(".ivet_control_navigation", a), (N) => {
      const E = N.classList;
      y ? E.add("expanded") : E.remove("expanded");
    });
  };
  f(l(".ivet_control_items", a), "scroll", fe), window.addEventListener("resize", () => {
    A(s.sections[i].fields[T]), fe();
  }), o.draw();
}
function St(s, e) {
  let t = !1, i, n = s.replace(/\n{2,}/g, `
`);
  e.maxLineLength && (n = n.split(`
`).map((o) => {
    if (o.length > e.maxLineLength) {
      const p = [];
      for (; o.length !== 0; )
        p.push(o.slice(0, e.maxLineLength)), o = o.slice(e.maxLineLength);
      return p.join(`
`);
    }
    return o;
  }).join(`
`));
  let a = !1;
  if (e.maxWordsPerLine && (n = n.split(`
`).map((o) => {
    const p = o.split(" ").filter((m) => m.length > 0);
    if (p.length <= e.maxWordsPerLine)
      return o;
    a = !0;
    const h = [];
    for (let m = 0; m < p.length; m += e.maxWordsPerLine)
      h.push(p.slice(m, m + e.maxWordsPerLine).join(" "));
    return h.join(`
`);
  }).join(`
`)), e.maxLength && n.length > e.maxLength && (n = n.slice(0, e.maxLength), t = !0, i = "maxLength"), !t && e.maxLines) {
    const o = n.split(`
`);
    o.length > e.maxLines && (n = o.slice(0, e.maxLines).join(`
`), t = !0, i = a ? "maxWordsPerLine" : "maxLines");
  }
  return { text: n, overflowed: t, reason: i };
}
function Qe(s, e) {
  const t = s.dataset.engravingState;
  if (t) {
    const i = JSON.parse(t);
    setTimeout(() => {
      for (const n of i.fields) {
        const a = l(`.ivet_container [data-section-id="${n.section}"][data-field-key="${n.key}"]`);
        if (a)
          if (a.dataset.fieldType === "image") {
            const o = l(".ivet_image_preview_draggable", a), p = l(".ivet_image_size", a);
            if (n?.value?.imageData) {
              const h = document.createElement("img");
              h.src = n.value.imageData, h.draggable = !1, o.innerHTML = "", o.appendChild(h);
            }
            p && n.value.scale && (p.value = n.value.scale.toString(), p.dispatchEvent(new Event("input")));
          } else {
            const o = l("textarea", a);
            o && (o.value = n.value.text || ""), o?.dispatchEvent(new Event("change"));
          }
      }
      setTimeout(() => {
        const n = Number.isInteger(e) ? e : i.currentSection;
        l(`.ivet_container [data-section="${n}"]`)?.click();
      }, 750);
    }, 100);
  }
}
function Ct() {
  const s = pe("[data-engraving-tool]");
  f(s, "click", (e) => {
    const t = e.target, i = t.dataset.engravingTool, n = JSON.parse(i || "{}");
    Ne(n, t);
  });
}
document.addEventListener("DOMContentLoaded", function() {
  Ct();
});
class Et extends ne {
  type = "engraving";
  hide() {
    return this;
  }
  render() {
    this.body.innerHTML = `
        <div class="advanced-option-label ${this.config.required ? "required" : ""}">${this.config.title}
        ${this.config.help_text ? `<div class="advanced-option-help-text">
        ?
        <span>${this.config.help_text}</span></div>` : ""}
        </div>
            <button class="button button button--filled uppercase button--full button--outlined" data-engraving-tool='${JSON.stringify({
      ...this.config.config,
      title: this.config.title || this.config.config.title
    })}'>
                ${this.config.config.buttonText || "Add Engraving"}
            </button>`;
    const e = l("button", this.body);
    return f(e, "click", () => {
      const t = e.dataset.engravingTool, i = JSON.parse(t || "{}");
      Qe(e), Ne(i, e, (n) => {
        this.setValue(n);
      });
    }), this.body;
  }
  show() {
    return this;
  }
}
class Tt extends ne {
  type = "text";
  hide() {
    return this;
  }
  render() {
    this.body.innerHTML = `
           <div class="container">
        <div class="advanced-option-label ${this.config.required ? "required" : ""}">
        ${this.config.title}
        ${this.config.help_text ? `<div class="advanced-option-help-text">
        ?
        <span>${this.config.help_text}</span></div>` : ""}
        </div>
            <div class="advanced-product-option-textarea">
                <textarea></textarea>
            </div>
           </div>
        `;
    const e = l("textarea", this.body);
    return f(e, "keyup", () => {
      this.setValue(e.value);
    }), this.body;
  }
  show() {
    return this;
  }
}
class kt extends ne {
  type = "multi-select";
  selectedValues = [];
  hide() {
    return this;
  }
  render() {
    this.body.innerHTML = `
        <div class="container">
        <div class="advanced-option-label ${this.config.required ? "required" : ""}">
        ${this.config.title}
        ${this.config.help_text ? `<div class="advanced-option-help-text">
        ?
        <span>${this.config.help_text}</span></div>` : ""}
        </div>
           <div class="advance-product-option-select-rows">
            </div>
        </div>
        `;
    const e = l(".advance-product-option-select-rows", this.body);
    for (const [t, i] of Object.entries(this.config.options)) {
      const n = document.createElement("div");
      n.classList.add("advance-product-option-select-row"), n.innerHTML = `
            <div class="advance-product-option-select-option-label">
            ${i.title}
            </div>
           <div class="advance-product-option-select advance-product-option-select-main-option">
                <div class="advanced-option-select-option advanced-option-selected-value">
                    <div class="advanced-option-selected">
                        -
                    </div>
                </div>
                <div class="advanced-product-option-select-options">
                </div>
            </div>
           <div class="advance-product-option-select advance-product-option-select-child-option">
                <div class="advanced-option-select-option advanced-option-selected-value">
                    <div class="advanced-option-selected">
                        -
                    </div>
                </div>
                <div class="advanced-product-option-select-options">
                </div>
            </div>
            `;
      const a = l(".advance-product-option-select-main-option", n), o = l(".advance-product-option-select-child-option", n), p = l(".advanced-product-option-select-options", a), h = l(".advanced-product-option-select-options", o);
      this.makeSelectableDropdown(a, i.title), this.makeSelectableDropdown(o, i.title);
      for (const m of i.options) {
        const T = this.makeSelectOption(m.title);
        p.appendChild(T), f(T, "click", () => {
          l(".advanced-option-selected", a).innerText = m.title, l(".advanced-option-selected", o).innerText = "-", h.innerHTML = "";
          for (const g of m.options) {
            const w = this.makeSelectOption(g);
            h.appendChild(w), f(w, "click", () => {
              l(".advanced-option-selected", o).innerText = g, this.selectedValues[t] = g, this.selectedValues.filter((P) => P && P !== "-").length === this.config.options.length ? this.setValue(this.selectedValues) : this.resetValue();
            });
          }
        });
      }
      e.appendChild(n);
    }
    return this.body;
  }
  makeSelectableDropdown(e, t = "Untitled") {
    const i = l(".advanced-option-selected-value", e);
    f(i, "click", (n) => {
      const a = e;
      if (a.classList.toggle("active"), n.preventDefault(), n.stopPropagation(), a.classList.contains("active")) {
        let o = function() {
          a.classList.remove("active"), window.removeEventListener("click", o);
        };
        window.addEventListener("click", o);
      }
      this.controller.mobileDrawer.openForSelectElement(e, t);
    });
  }
  makeSelectOption(e) {
    const t = document.createElement("div");
    return t.classList.add("advanced-option-select-option"), t.innerHTML = `
                    <div class="aoso-label">
                        ${e}
                    </div>
            `, t;
  }
  show() {
    return this;
  }
}
class Pt extends ne {
  type = "image";
  hide() {
    return this;
  }
  render() {
    this.body.innerHTML = `
          <div class="advanced-option-label ${this.config.required ? "required" : ""}">
          ${this.config.title}
          ${this.config.help_text ? `<div class="advanced-option-help-text">
        ?
        <span>${this.config.help_text}</span></div>` : ""}
          </div>
        <div class="advanced-product-option-image">
            <div class="advanced-option-help-text">${this.config.help_text}</div>
            <div class="apo-image-container">
                <div class="apo-image">
                </div>
                <div class="apo-trigger">
                    <button class="shopify-payment-button__button shopify-payment-button__button--unbranded">
                        Upload image
                    </button>
                </div>
                <div class="apo-remove-image">
                    <div class="apo-image-name"></div>
                    <span class="apo-remove-image-text">Remove image</span>
                </div>
            </div>
            <div class="advanced-option-help-text">
                Compatible file extensions to upload: png, jpg, jpeg, gif <br/>
                Max dimensions: 9000 x 9000px
            </div>
            <input type="file" accept="image/*" />
        </div>
        `;
    const e = l("button", this.body), t = l("input[type=file]", this.body), i = l(".apo-image", this.body), n = l(".apo-remove-image", this.body), a = l(".apo-image-name", this.body), o = () => {
      i.innerHTML = "", this.resetValue();
    };
    return f(e, "click", () => t.click()), f(n, "click", () => {
      o(), n.style.display = "none", e.style.display = "block", t.value = "";
    }), f(t, "change", (p) => {
      const h = p.target?.files?.[0];
      if (h) {
        a && (a.innerHTML = h.name);
        const m = new FileReader();
        m.onload = (T) => {
          const g = new Image();
          g.onload = () => {
            o(), g.style.cursor = "pointer", f(g, "click", () => t.click()), i.appendChild(g), this.setValue(g.src), n.style.display = "block", e.style.display = "none";
          }, g.src = T.target.result;
        }, m.readAsDataURL(h);
      }
    }), this.body;
  }
  show() {
    return this;
  }
}
class Mt {
  openForSelectElement(e, t = "Select an option") {
    if (this.removeDrawer(), window.innerWidth > 968) return;
    const i = e.querySelector(".advanced-product-option-select-options");
    if (i) {
      const n = document.createElement("div");
      n.classList.add("advanced-product-options", "mobile"), n.innerHTML = `
                <div class="advanced-product-option-mobile-shadow"></div>
                <div class="advanced-product-option active-product-option-show">
                    <div class="advance-product-option-select active">
                        <div class="advanced-product-option-select-options">
                            <div class="advanced-product-option-select-options-mobile-title">
                                ${t}
                                <div class="apo-close-icon">
                                    ${Vt}
                                </div>
                            </div>
                            ${i.outerHTML}
                        </div>
                    </div>
                </div>
        `, document.body.appendChild(n);
      const a = e.querySelectorAll(".advanced-product-option-select-options .advanced-option-select-option"), o = n.querySelectorAll(".advanced-product-option-select-options .advanced-option-select-option");
      for (let p = 0; p < o.length; p++)
        o[p].addEventListener("click", () => {
          a[p].dispatchEvent(new Event("click")), this.goToNextElementOrClose(l(".advanced-product-option-select-options", e));
        });
      f(l(".advanced-product-option-mobile-shadow", n), "click", this.niceRemoveDrawer.bind(this)), f(l(".apo-close-icon", n), "click", this.niceRemoveDrawer.bind(this)), et(e, 100), this.toggleBodyOverflow();
    }
  }
  goToNextElementOrClose(e) {
    const t = this.checkForNextElement(e);
    if (t) {
      setTimeout(() => {
        t.querySelector(".advanced-option-selected-value").click();
      }, 0);
      return;
    }
    this.niceRemoveDrawer();
  }
  checkForNextElement(e) {
    const t = e.closest(".advanced-product-option"), i = Array.from(t.querySelectorAll(".advanced-product-option-select-options")), n = t.nextElementSibling;
    n.classList.contains("active-product-option-show") && i.push(
      ...Array.from(n.querySelectorAll(".advanced-product-option-select-options"))
    );
    let a = !1, o = null;
    for (const p of i)
      if (!a && p === e)
        a = !0;
      else if (a) {
        o = p;
        break;
      }
    return o ? o.closest(".advance-product-option-select") : null;
  }
  toggleBodyOverflow() {
    document.body.style.overflow = document.querySelectorAll(".advanced-product-options.mobile").length && window.innerWidth <= 968 ? "hidden" : "";
  }
  removeDrawer() {
    Array.from(document.querySelectorAll(".advanced-product-options.mobile")).forEach((e) => {
      e.parentElement.removeChild(e);
    }), this.toggleBodyOverflow();
  }
  niceRemoveDrawer() {
    Array.from(document.querySelectorAll(".advanced-product-options.mobile")).forEach((e) => {
      e.classList.add("invisible"), e.querySelector(".active-product-option-show").addEventListener("transitionend", this.onRemoveAnimationEnd);
    }), setTimeout(() => this.toggleBodyOverflow(), 300);
  }
  onRemoveAnimationEnd(e) {
    const t = e.target.closest(".advanced-product-options.mobile");
    t && t.parentElement.removeChild(t), setTimeout(() => this.toggleBodyOverflow(), 300);
  }
}
class It extends ne {
  type = "variant";
  options = [];
  hide() {
    return this;
  }
  render() {
    return this.renderListVariation();
  }
  renderListVariation() {
    this.body.innerHTML = `
        <div class="advanced-option-label ${this.config.required ? "required" : ""}">
        ${this.config.title}
        ${this.config.help_text ? `<div class="advanced-option-help-text">
        ?
        <span>${this.config.help_text}</span></div>` : ""}
        </div>
            <div class="advance-product-option-choices">
            </div>
        </div>
     `;
    let e = !1;
    const t = this.config.maxListItems || 0, i = l(".advance-product-option-choices", this.body);
    if (this.config.config.options.forEach((n, a) => {
      const o = document.createElement("div");
      o.classList.add("advance-product-option-choice"), t && a + 1 > t && (o.style.display = "none", e = !0), o.innerHTML = `
                    ${n.thumbnail_image ? `
                    <div class="apoc-img">
                        <img src="${n.thumbnail_image}"/>
                    </div>
                    ` : ""}
                    <div class="apoc-label">
                        ${n.title}
                    </div>
             ${n.price_addon && parseInt(n.price_addon) ? `
                    <div class="apoc-price">+£${n.price_addon}</div>` : ""}
          `, i.appendChild(o), f(o, "click", () => {
        o.classList.add("selected"), this.options.map((p) => p !== o && p.classList.remove("selected")), this.setValue(n);
      }), this.options.push(o);
    }), e) {
      const n = document.createElement("div");
      n.classList.add("apoc-show-button"), n.innerHTML = `
            <button class="button button--filled uppercase button--full previous-button">
            ${this.config.maxListItemsLabel || "Show more options"}
            </button>
            `, i.appendChild(n), f(n, "click", () => {
        i.querySelectorAll(".advance-product-option-choice").forEach((a) => {
          a.style.display = "flex";
        }), n.style.display = "none";
      });
    }
    return this.body;
  }
  show() {
    return this;
  }
}
class $t extends ne {
  type = "variant";
  options = [];
  bodyOptionsHolder;
  hide() {
    return this;
  }
  render() {
    return this.renderSelectVariation();
  }
  renderSelectVariation() {
    this.body.innerHTML = `
        <div class="advanced-option-label ${this.config.required ? "required" : ""}">
        ${this.config.title}
        ${this.config.help_text ? `<div class="advanced-option-help-text">
        ?
        <span>${this.config.help_text}</span></div>` : ""}
        </div>
        <div class="advance-product-option-select">
            <div class="advanced-option-select-option advanced-option-selected-value">
                <div class="advanced-option-selected">
                    ${this.config.selectLabel || "Choose an option...."}
                </div>
            </div>
            <div class="advanced-product-option-select-options">
            </div>
        </div>
     `, this.bodyOptionsHolder = l(".advanced-product-option-select-options", this.body);
    const e = l(".advanced-option-selected-value", this.body);
    return f(e, "click", (t) => {
      const i = l(".advance-product-option-select", this.body);
      if (this.controller.mobileDrawer.openForSelectElement(i, this.config.title), i.classList.toggle("active"), t.preventDefault(), t.stopPropagation(), i.classList.contains("active")) {
        let n = function() {
          i.classList.remove("active"), window.removeEventListener("click", n);
        };
        window.addEventListener("click", n);
      }
    }), this.renderSelectOptions(), this.body;
  }
  renderSelectOptions() {
    this.config?.config?.options, this.config.config.options.forEach((e) => {
      const t = document.createElement("div");
      t.classList.add("advanced-option-select-option"), t.innerHTML = `
                    ${e.thumbnail_image || e.product_image ? `
                       <div class="aoso-thumbnail aoso-thumbnail-rounded aoso-thumbnail-small">
                         <img src="${e.thumbnail_image || e.product_image}"/>
                        </div>
                    ` : ""}
                    <div class="aoso-label">
                        ${e.title}
                    </div>
                    ${e.price_addon && parseInt(e.price_addon) ? `
                    <div class="aoso-price">+£${e.price_addon}</div>` : ""}
            `, f(t, "click", () => {
        t.classList.add("selected");
        const i = l(".advanced-option-selected-value", this.body);
        i.innerHTML = t.innerHTML, this.options.forEach((n) => n !== t && n.classList.remove("selected")), this.setValue(e);
      }), this.bodyOptionsHolder.appendChild(t), this.options.push(t);
    });
  }
  show() {
    return this;
  }
}
class Bt extends ne {
  type = "variant";
  charmsContainer;
  selectionContainer;
  selectionListItemsContainer;
  mainAddonToggleCheckbox;
  priceBreakDownTable;
  rearrangeInfoHelper;
  selectedCharms = [];
  hide() {
    return this;
  }
  render() {
    this.config.first_item_is_addon_row && this.config.config?.options.length && (this.config.charm_addon = this.config.config.options.splice(0, 1)[0]);
    const e = this.config.list_item_title || "Personalised Items", t = this.config.add_charm_button && this.config.charm_addon ? `
            <div class="advanced-option-charm-builder-selection-add-button">
              <div class="advanced-option-charm-builder-selection-add-button-checkbox">
                <input 
                    type="checkbox" 
                    class="advanced-option-charm-builder-selection-add-button-checkbox-input"
                 />
                <label 
                class="advanced-option-charm-builder-selection-add-button-checkbox-label"></label>
              </div>
              <div class="advanced-option-charm-builder-selection-add-button-text">
               ${this.config.add_charm_button}
              </div>
              ${this.config.charm_addon.price_addon && parseInt(this.config.charm_addon.price_addon) && `
                <div class="advanced-option-charm-builder-selection-add-button-price">
                 &pound;${this.config.charm_addon.price_addon}
                </div> 
              `}
            </div> 
            ` : "";
    return this.body.innerHTML = `
        <div class="advanced-option-label ${this.config.required ? "required" : ""}">
        ${this.config.title}
        ${this.config.help_text ? `<div class="advanced-option-help-text">
        ?
        <span>${this.config.help_text}</span></div>` : ""}
        </div>
            <div class="advanced-option-charm-builder">
            </div>
            ${t}
            <div class="advanced-option-charm-builder-selection">
                <div class="advanced-option-charm-builder-selection-title">
                    ${e}
                </div>
             <div class="advanced-option-charm-builder-selection-list"></div>
             <div class="advanced-option-charm-rearrange-info">
                To change the order of the charms, click and hold a charm,
                then drag it to your desired position and release.
             </div>
             <div class="advanced-option-charm-price-breakdown"></div>
            </div>
        </div>
     `, t !== "" && (this.mainAddonToggleCheckbox = this.body.querySelector(".advanced-option-charm-builder-selection-add-button-checkbox-input"), this.mainAddonToggleCheckbox?.addEventListener("change", (i) => {
      i.target.checked ? this.addMainAddonToSelectionList() : this.removeMainAddonFromSelectionList(), i.stopPropagation();
    }), this.mainAddonToggleCheckbox?.closest(".advanced-option-charm-builder-selection-add-button")?.addEventListener("click", () => {
      this.mainAddonToggleCheckbox?.click();
    })), this.charmsContainer = this.body.querySelector(".advanced-option-charm-builder"), this.selectionContainer = this.body.querySelector(".advanced-option-charm-builder-selection"), this.selectionListItemsContainer = this.body.querySelector(".advanced-option-charm-builder-selection-list"), this.priceBreakDownTable = this.body.querySelector(".advanced-option-charm-price-breakdown"), this.rearrangeInfoHelper = this.body.querySelector(".advanced-option-charm-rearrange-info"), this.addCharmElementsToSelectContainer(), this.toggleSelectionContainer(), this.body;
  }
  addCharmElementsToSelectContainer() {
    for (const e of this.config.config.options)
      this.addOptionToDom(e);
  }
  generatePriceBreakdownContent() {
    let e = "";
    if (this.selectedCharms.length) {
      let t = 0, i = 0;
      const n = "&pound;" + this.selectedCharms.reduce((p, h) => (i += parseFloat(h.option.price_addon) || 0, h.option === this.config.charm_addon ? p : (t++, h.option.price_addon ? p + parseFloat(h.option.price_addon) : p)), 0).toFixed(2), a = this.mainAddonIsInSelectionList(), o = "&pound;" + (a && +this.selectedCharms[0].option?.price_addon || 0).toFixed(2);
      i = "&pound;" + i.toFixed(2), e = `
            <div class='advanced-option-charm-price-breakdown-rows'>
                <div class="advanced-option-charm-price-breakdown-row">
                    x${t} ${this.config.config.title} - ${n}        
                </div>
                <div class="advanced-option-charm-price-breakdown-row">
                    x${a ? "1" : "0"} ${this.config.charm_addon.title} - ${o}
                </div>
            </div>
            <div class="advanced-option-charm-price-breakdown-total">
                <div>Total</div><div>${i}</div>
            </div>
         `, this.priceBreakDownTable.innerHTML = e;
    }
  }
  addOptionToDom = (e) => {
    const t = this.config.config.options;
    let i = this.config.maxElementsPerLine || 9;
    Math.max(5, Math.min(i, t.length));
    const n = e.product_image || e.thumbnail_image, a = document.createElement("div"), o = parseFloat(e.price_addon || "0").toFixed(2);
    return a.draggable = !1, a.classList.add("advanced-option-charm-builder-option"), a.innerHTML = `
        <img src='${n}' draggable="false" alt="${e.title}" />
        <div class="price">&pound;${o}</div>
        `, this.charmsContainer.appendChild(a), a.addEventListener("click", () => this.addCharmToSelectionContainerOnClick(e)), a;
  };
  addCharmToSelectionContainerOnClick(e) {
    const t = this.createCharmSelectionElement(e);
    this.selectionListItemsContainer.appendChild(t), this.selectedCharms.push({
      option: e,
      element: t
    }), this.addDragListenerToAddedItem(t), this.updateValue(), t.querySelector(".advanced-option-charm-builder-selection-item-remove-button")?.addEventListener("click", () => {
      const i = this.selectedCharms.findIndex((n) => n.element === t);
      i > -1 && (this.selectedCharms[i]?.element?.remove(), this.selectedCharms.splice(i, 1), this.updateValue());
    });
  }
  createCharmSelectionElement(e) {
    const t = document.createElement("div");
    return t.classList.add("advanced-option-charm-builder-selection-item"), t.innerHTML = `
            <div class="advanced-option-charm-builder-selection-item-image">
                <img src="${e.product_image || e.thumbnail_image}" alt="${e.title}"/>
            </div>
            <div class="advanced-option-charm-builder-selection-item-remove-button">
                Remove
            </div> 
        `, t;
  }
  createPlusElement() {
    const e = document.createElement("div");
    return e.classList.add("advanced-option-charm-builder-selection-item"), e.innerHTML = `
            <div class="advanced-option-charm-builder-selection-item-plus-icon">
                +
            </div>
        `, e;
  }
  addMainAddonToSelectionList() {
    if (!this.mainAddonIsInSelectionList()) {
      const e = this.createCharmSelectionElement(this.config.charm_addon);
      this.selectionListItemsContainer.prepend(e), this.selectedCharms.unshift({
        option: this.config.charm_addon,
        element: e
      }), e.querySelector(".advanced-option-charm-builder-selection-item-remove-button")?.addEventListener("click", () => {
        this.removeMainAddonFromSelectionList();
      }), this.updateValue();
    }
  }
  removeMainAddonFromSelectionList() {
    this.mainAddonIsInSelectionList() && (this.selectedCharms[0].element.remove(), this.selectedCharms.shift(), this.updateValue(), this.mainAddonToggleCheckbox.checked = !1);
  }
  mainAddonIsInSelectionList() {
    return !(!this.selectedCharms.length || this.selectedCharms[0].option !== this.config.charm_addon);
  }
  addDragListenerToAddedItem(e) {
    let i = null, n = !1;
    const a = (v) => {
      const P = e.getBoundingClientRect();
      e.style.width = `${P.width}px`, e.style.height = `${P.height}px`, e.style.transition = "none", e.style.position = "absolute", e.style.top = "0px", e.style.left = "0px", window.addEventListener("mousemove", g), v && p(v);
    }, o = () => {
      e.style.width = "", e.style.height = "", e.style.position = "", window.removeEventListener("mousemove", g), i?.remove();
    }, p = (v) => {
      const P = e.getBoundingClientRect(), x = parseInt(e.style.top || "0"), F = parseInt(e.style.left || "0");
      e.style.top = `${x + v.clientY - P.y - P.width / 2}px`, e.style.left = `${F + v.clientX - P.x - P.height / 2}px`;
    }, h = () => {
      i && i.parentElement?.removeChild(i), i?.remove(), i = null, o(), n = !1, this.updateValue();
    }, m = () => {
      i = e.cloneNode(!0), e.parentElement?.insertBefore(i, e), i.querySelector(".advanced-option-charm-builder-selection-item-remove-button")?.remove(), i.style.opacity = "0.5";
    }, T = () => {
      if (!i) return;
      const v = e.getBoundingClientRect();
      for (const P of this.selectedCharms) {
        const { element: x } = P;
        if (x === e || P.option === this.config.charm_addon) continue;
        const F = x.getBoundingClientRect(), W = v.left < F.left && v.right > F.left, D = v.left < F.right && v.right > F.right, H = v.top < F.top && v.bottom >= F.top, A = v.top < F.bottom && v.bottom > F.bottom;
        if ((H || A) && (W || D)) {
          const G = v.width * v.height, Be = Math.max(F.left, v.left), Se = Math.min(F.right, v.right), Ce = Math.max(F.top, v.top), Ee = Math.min(F.bottom, v.bottom), se = Se - Be, Te = Ee - Ce;
          if (se * Te / G > 0.75) {
            const ue = this.selectedCharms.findIndex((fe) => fe.element === e), ae = this.selectedCharms.findIndex((fe) => fe.element === x);
            ue < ae ? x.after(e, i) : x.before(e, i);
            const Fe = this.selectedCharms[ue];
            this.selectedCharms[ue] = this.selectedCharms[ae], this.selectedCharms[ae] = Fe;
          }
        }
      }
    };
    function g(v) {
      n || window.removeEventListener("pointermove", g), p(v), T();
    }
    const w = (v) => {
      const P = e.querySelector(".advanced-option-charm-builder-selection-item-remove-button");
      return v.target === P || P?.contains(v.target);
    };
    e.addEventListener("pointerdown", (v) => {
      this.selectedCharms.length < 2 || w(v) || (n && h(), n = !0, m(), a(v));
    }), e.addEventListener("pointerup", () => {
      h();
    }), window.addEventListener("pointerup", () => {
      h();
    });
  }
  buildSelectionString() {
    return this.selectedCharms.filter((e) => e.option !== this.config.charm_addon).map((e) => e.option.title).join("");
  }
  buildSelectionImage() {
    return this.selectedCharms.map((e) => e.option.product_image || e.option.thumbnail_image).join("|");
  }
  toggleSelectionContainer() {
    this.selectionContainer.style.display = this.selectedCharms.length ? "block" : "none", this.selectedCharms.length && this.generatePriceBreakdownContent();
  }
  checkIfShouldAddPlusButton() {
    const e = this.selectionListItemsContainer.querySelector(".advanced-option-charm-builder-selection-item-plus-icon"), t = this.selectedCharms.length > 1;
    this.mainAddonIsInSelectionList() && t ? e || this.selectionListItemsContainer.children[0].after(this.createPlusElement()) : e?.parentElement?.remove();
  }
  checkIfShouldShowInstruction() {
    const e = this.selectedCharms.find((t) => t.option !== this.config.charm_addon);
    this.rearrangeInfoHelper.style.display = e ? "block" : "none";
  }
  updateValue() {
    this.setValue(this.selectedCharms), this.toggleSelectionContainer(), this.checkIfShouldAddPlusButton(), this.checkIfShouldShowInstruction();
  }
  show() {
    return this;
  }
}
function Ot(s, e) {
  return e.layout === "list" ? new It(s, e) : e.layout === "charm-builder" ? new Bt(s, e) : new $t(s, e);
}
class At extends ne {
  type = "wrapping";
  priceElement = document.createElement("div");
  modelElement = document.createElement("div");
  modelRendered = !1;
  build_prices = [];
  hide() {
    return this;
  }
  render() {
    return this.loadPopupModel(), this.body;
  }
  showPopupModel() {
    this.modelElement.classList.add("open"), setTimeout(() => {
      this.modelElement.classList.add("show"), document.body.style.overflow = "hidden";
    }, 10);
  }
  closePopupModel() {
    const e = () => {
      this.modelElement.classList.remove("open"), document.body.style.overflow = "", this.modelElement.removeEventListener("transitionend", e);
    };
    this.modelElement.addEventListener("transitionend", e), this.modelElement.classList.remove("show");
  }
  loadPopupModel() {
    if (this.modelRendered) return;
    const e = document.createElement("div");
    e.classList.add("gift-wrapping-option-modal"), e.innerHTML = `
           <div class="gift-wrapping-option-modal-inner"></div> 
        `;
    const t = document.createElement("div");
    t.classList.add("gift-wrapping-option-modal-inner-content"), t.innerHTML = `
            <div class="gift-wrapping-option-modal-header">
                <div class="gift-wrapping-option-modal-title">${this.config.title}</div>
                <div class="gift-wrapping-option-modal-close">
                    ${Ge()}
                </div>
            </div>
        `, this.config.description && (t.innerHTML += `<div class="gift-wrapping-option-modal-description">${this.config.description}</div>`), t.innerHTML += `
        <div class="gift-wrapping-option-modal-optional-text">
            <span>Gift Packaging (Optional):</span>
            <span>Select any combination</span>
        </div>
        `, f(
      t.querySelector(".gift-wrapping-option-modal-close"),
      "click",
      this.closePopupModel.bind(this)
    );
    for (const o of this.config.options)
      t.appendChild(this.renderMainWrappingContent(o));
    const i = document.createElement("div");
    i.classList.add("gift-wrapping-option-modal-bottom"), this.updatePriceElement(), e.firstElementChild.appendChild(t), this.priceElement.classList.add("gift-wrapping-option-modal-price");
    const n = document.createElement("button");
    n.classList.add("full"), n.innerHTML = "Add to bag";
    const a = document.createElement("button");
    a.innerHTML = "Continue without gift wrapping", f(n, "click", () => {
      this.controller.triggerEvent("onAddToCart").then(() => {
        this.closePopupModel();
      });
    }), f(a, "click", () => {
      this.setValue([]), this.modelElement.querySelectorAll(".selected").forEach((o) => o.classList.remove("selected")), this.controller.triggerEvent("onAddToCart");
    }), i.append(this.priceElement, n, a), e.firstElementChild.appendChild(i), document.body.appendChild(e), this.modelElement = e, this.modelRendered = !0;
  }
  updatePriceElement() {
    this.priceElement.innerHTML = `
        <span>Total price:</span>
        <span>${"£" + this.controller.getPrice().toFixed(2)}</span>
        `;
  }
  renderMainWrappingContent(e) {
    const t = document.createElement("div");
    t.classList.add("gift-wrapping-option"), t.innerHTML = `
        <div class="gift-wrapping-option-header">
            <div class="gift-wrapping-option-image">
                <img src="${e.thumbnail_image || e.product_image}" />
           </div>
           <div class="gift-wrapping-option-title-container">
            <div class="gift-wrapping-option-title">
               ${e.title}
            </div>
            <div class="gift-wrapping-option-price">
                £${e.price_addon}
            </div>
           </div>
        </div>
        `;
    const i = {
      selected: !1,
      price: e.price_addon,
      id: e.id,
      type: "main"
    };
    this.build_prices.push(i), f(t.querySelector(".gift-wrapping-option-header"), "click", () => {
      t.classList.toggle("selected"), i.selected = t.classList.contains("selected"), i.selected || t.querySelectorAll(".selected").forEach((o) => {
        o.classList.remove("selected"), o.querySelector("input[type=checkbox]").checked = !1, this.build_prices[+o.dataset.index].selected = !1;
      }), this.prerenderBuiltPrices();
    });
    const n = document.createElement("div");
    n.classList.add("gift-wrapping-option-children"), t.appendChild(n), n.innerHTML += `
        <div class="gift-wrapping-option-children-inner"></div>
        `;
    let a = 0;
    for (const o of e.options)
      n.lastElementChild.appendChild(this.renderWrappingChildOption(o, a++));
    return t;
  }
  prerenderBuiltPrices() {
    const e = this.build_prices.filter((t) => t.selected);
    this.setValue(e), console.log(e), this.controller.processValueUpdate(), this.updatePriceElement();
  }
  renderWrappingChildOption(e, t) {
    const i = document.createElement("div");
    i.classList.add("gift-wrapping-option-child"), i.style.transitionDelay = (t + 1) * 250 + "ms", i.innerHTML = `
        <div class="inner-wrapping-option-info"">
            <div class="inner-wrapping-option-info-text">
                <div class="inner-wrapping-title">${e.title}</div>
                <div class="inner-wrapping-help">${e.help_text}</div>
            </div>
            <div class="inner-wrapping-option-price">
            <div class="inner-wrapping-price">£${(+e.price_addon).toFixed(2)}</div>
            <label class="switch">
                <input type="checkbox" class="checkbox" />
                <span class="slider round"></span>
            </label>
            </div>
        </div>
        `;
    const n = document.createElement("div"), a = document.createElement("div");
    a.classList.add("inner-wrapping-option-field"), n.classList.add("inner-wrapping-option-field-inner"), a.appendChild(n), n.innerHTML = `
            <div class="inner-wrapping-option-field-instruction">${e.field_instruction || "Please enter"}</div>
        `, e.type === "text" ? n.innerHTML += `
                <input type="text" placeholder="${e.placeholder || "Please enter"}" />           
            ` : n.innerHTML += `
                <select>
                    <option value="" disabled selected>${e.placeholder || "Please select"}</option>
                    ${e.options.map((m) => `<option value="${m}">${m}</option>`).join("")}
                </select>
            `;
    const o = n.lastElementChild, p = i.querySelector(".checkbox"), h = {
      selected: !1,
      price: e.price_addon,
      id: e.id,
      type: e.type,
      value: ""
    };
    return this.build_prices.push(h), i.dataset.index = (this.build_prices.length - 1).toString(), f(p, "change", () => {
      p.checked ? (i.classList.add("selected"), h.selected = !0) : (i.classList.remove("selected"), h.selected = !1), this.prerenderBuiltPrices();
    }), f(o, "change", () => {
      h.value = o.value, this.prerenderBuiltPrices();
    }), i.appendChild(a), f(i, "click", (m) => {
      m.stopPropagation();
    }), i;
  }
  show() {
    return this;
  }
}
var Ze = /* @__PURE__ */ ((s) => (s.Text = "text", s.Select = "select", s.Image = "image", s.Variant = "variant", s.Engraving = "engraving", s.MultiSelect = "multi-select", s.GiftWrapping = "wrapping", s.FingerPrint = "finger_print", s))(Ze || {});
class Ft extends ne {
  type = Ze.FingerPrint;
  hide() {
    return this;
  }
  renderTabs() {
    const e = document.createElement("div");
    e.classList.add("apo-fingerprint-tabs");
    const t = this.config.upload_title || "Upload", i = this.config.previous_order_title || "Use Print From Previous Order";
    e.innerHTML = `
      <div class="apo-tabs">
        <button class="apo-tab-btn active" data-tab="upload">${t}</button>
        <button class="apo-tab-btn" data-tab="previous">${i}</button>
      </div>
      <div class="apo-tab-panels">
        <div class="apo-tab-panel active" data-tab-panel="upload">
          <div class="">${this.config.upload_text || "Please upload your fingerprint image if you already have one."}</div>
          <button class="shopify-payment-button__button shopify-payment-button__button--unbranded apo-upload-trigger">${this.config.upload_button || "Upload"}</button>
          <input type="file" accept="image/*" style="display:none" />
        </div>
        <div class="apo-tab-panel" data-tab-panel="previous">
          <input type="text" class="apo-order-input" placeholder="${this.config.previous_order_text || "Enter order number"}" />
        </div>
      </div>
    `;
    const n = e.querySelectorAll(".apo-tab-btn");
    n.forEach((h) => {
      f(h, "click", () => {
        n.forEach((g) => g.classList.remove("active")), h.classList.add("active");
        const m = h.dataset.tab;
        e.querySelectorAll(".apo-tab-panel").forEach((g) => {
          g.dataset.tabPanel === m ? g.classList.add("active") : g.classList.remove("active");
        });
      });
    });
    const a = l(".apo-upload-trigger", e), o = l('input[type="file"]', e);
    a && o && (f(a, "click", () => o.click()), f(o, "change", (h) => {
      const m = h.target?.files?.[0];
      if (m) {
        const T = new FileReader();
        T.onload = (g) => {
          const w = g.target.result;
          a.textContent = "Uploaded", this.setValue({ need_kit: !1, source: "upload", imageDataUrl: w, fileName: m.name });
        }, T.readAsDataURL(m);
      }
    }));
    const p = l(".apo-order-input", e);
    return p && f(p, "keyup", () => {
      const h = p.value.trim();
      this.setValue({ need_kit: !1, source: "previous_order", order_number: h });
    }), e;
  }
  render() {
    const e = this.config.title || "Do you need a free fingerprint kit?";
    this.body.innerHTML = `
      <div class="container">
        <div class="advanced-option-label ${this.config.required ? "required" : ""}">${e}
         ${this.config.help_text ? `<div class="advanced-option-help-text">
        ?
        <span>${this.config.help_text}</span></div>` : ""}
        </div>
        <div class="apo-fingerprint-yesno">
          <button class="button button--outlined button--small apo-yes active" data-choice="yes">Yes</button>
          <button class="button button--outlined button--small apo-no" data-choice="no">No</button>
        </div>
        <div class="apo-fingerprint-extra" style="display:none"></div>
      </div>
    `;
    const t = l(".apo-yes", this.body), i = l(".apo-no", this.body), n = l(".apo-fingerprint-extra", this.body), a = (o) => {
      t.classList.toggle("active", o), i.classList.toggle("active", !o), o ? (n.style.display = "none", n.innerHTML = "", this.setValue({ need_kit: !0 })) : (n.style.display = "block", n.hasChildNodes() || n.appendChild(this.renderTabs()));
    };
    return f(t, "click", () => {
      a(!0), t.classList.add("button--filled"), t.classList.remove("button--outlined"), i.classList.add("button--outlined"), i.classList.remove("button--filled");
    }), f(i, "click", () => {
      a(!1), t.classList.add("button--outlined"), t.classList.remove("button--filled"), i.classList.add("button--filled"), i.classList.remove("button--outlined");
    }), this.body;
  }
  show() {
    return this;
  }
}
class Dt {
  sections = 0;
  current_section = 0;
  options = [];
  target;
  initialised = !1;
  navigation;
  priceManager;
  events = {};
  mobileDrawer;
  wrappingOption;
  constructor() {
    this.navigation = new ot(this), this.priceManager = new at(this), this.mobileDrawer = new Mt();
  }
  parseConfiguration(e) {
    if (e && e?.sections) {
      this.sections = e.sections.length - 1;
      let t = 0;
      for (const i of e.sections) {
        for (const n of i.items)
          switch (n?.type || "") {
            case "wrapping":
              this.wrappingOption || (this.wrappingOption = new At(this, n), this.wrappingOption.loadPopupModel());
              break;
            case "variant":
              this.options.push(Ot(this, n)), this.options[this.options.length - 1].setSection(t);
              break;
            case "image":
              this.options.push(new Pt(this, n)), this.options[this.options.length - 1].setSection(t);
              break;
            case "text":
              this.options.push(new Tt(this, n)), this.options[this.options.length - 1].setSection(t);
              break;
            case "engraving":
              this.options.push(new Et(this, n)), this.options[this.options.length - 1].setSection(t), this.options[this.options.length - 1].config.config.sections.forEach((a) => {
                a.fields.forEach((o) => {
                  o.type === "text" && !o.fonts.length && (o.fonts = [
                    { label: "Helvetica", font: "helvetica" },
                    { label: "Times new roman", font: "times new roman" },
                    { label: "Alsscrp", font: "allscrp" }
                  ]);
                });
              });
              break;
            case "multi-select":
              this.options.push(new kt(this, n)), this.options[this.options.length - 1].setSection(t);
              break;
            case "finger_print":
              this.options.push(new Ft(this, n)), this.options[this.options.length - 1].setSection(t);
              break;
          }
        t++;
      }
    }
  }
  setTarget(e) {
    return this.target = e, this;
  }
  getTarget() {
    return this.target;
  }
  setPrice(e) {
    return this.priceManager.setPrice(e), this.priceManager.calculatedPrice(), this;
  }
  render() {
    this.initialised || (this.runForAllOptions((e) => e.performRender()), this.getTarget().appendChild(this.priceManager.render()), this.getTarget().appendChild(this.navigation.render()), this.processValueUpdate(), this.initialised = !0);
  }
  getCurrentCartButtonHelpText() {
    const e = this.options.find((i) => i.isVisible() && !i.getValue()?.[0]), t = e?.config && e.config.cart_button_help_text;
    return t && t.trim().length ? t : void 0;
  }
  hideAll() {
    this.runForAllOptions((e) => e.performHide());
  }
  processValueUpdate() {
    this.runThroughShowAndHide(), this.priceManager.calculatedPrice();
    const e = this.allItemsToCurrentSectionValid();
    this.current_section > 0 ? this.navigation.showPreviousButton() : this.navigation.hidePreviousButton(), this.hasNextSection() ? this.navigation.setNextStepState() : this.navigation.setAddToCartState(), e ? this.navigation.setNextButtonEnabledState() : this.navigation.setNextButtonDisabledState();
  }
  setIfInStock(e) {
    e ? (this.current_section > 0 ? this.navigation.showPreviousButton() : this.navigation.hidePreviousButton(), this.hasNextSection() ? this.navigation.setNextStepState() : this.navigation.setAddToCartState()) : this.navigation.disableButtons();
  }
  onButtonNext() {
    if (this.allItemsToCurrentSectionValid(!0)) {
      const e = this.hasNextSection();
      typeof e == "number" ? (this.current_section = e, this.processValueUpdate()) : this.wrappingOption ? this.wrappingOption.showPopupModel() : this.triggerEvent("onAddToCart");
    }
  }
  onPreviousButtonState() {
    this.current_section > 0 && (this.current_section--, this.processValueUpdate());
  }
  hasNextSection() {
    return this.current_section === this.sections ? !1 : this.options.find((e) => e.getSection() > this.current_section && this.validateRule(e))?.getSection() || !1;
  }
  allItemsToCurrentSectionValid(e = !1) {
    let t = !0;
    return this.options.filter((i) => i.getSection() <= this.current_section).forEach((i) => {
      i.config?.required && !i.getValue()?.length && this.validateRule(i) ? (t = !1, e ? i.showError() : i.hideError()) : i.hideError();
    }), t;
  }
  getAllValidCartOptions() {
    return this.options.filter((e) => !(!this.validateRule(e) || !e.getValue()?.[0])).concat(this.wrappingOption ? [this.wrappingOption] : []);
  }
  runThroughShowAndHide() {
    for (const e of this.options) {
      if (e.getSection() !== this.current_section) {
        e.performHide();
        continue;
      }
      const t = this.options.findIndex((o) => o === e), i = t > 0 ? this.options.slice(0, t) : null;
      if (!this.validateRule(e)) {
        e.performHide();
        continue;
      }
      if (!i) {
        e.performShow();
        continue;
      }
      if (!!i.find((o) => !o.getValue()?.[0] && o.config?.required && this.validateRule(o))) {
        e.performHide();
        continue;
      }
      e.performShow();
    }
  }
  validateRule(e) {
    if (e.config?.rules && e.config.rules.length)
      for (const t of e.config.rules) {
        const i = this.options.findIndex((p) => p === e), a = (i > 0 ? this.options.slice(0, i) : null)?.find(
          (p) => p.config.variant_id === t.matches
        ), o = a && a.getValue()?.[0]?.id;
        if (!a || !o || !this.validateRule(a) || t.type === "not_in" && t.value?.includes(o) || t.type === "in" && !t.value?.includes(o))
          return !1;
      }
    return !0;
  }
  showAll() {
    this.runForAllOptions((e) => e.performShow());
  }
  runForAllOptions(e) {
    this.target && this.hasOptions() && this.options.forEach(e);
  }
  hasOptions() {
    return this.options.length > 0;
  }
  addEvent(e, t) {
    return this.events[e] || (this.events[e] = []), this.events[e].push(t), this;
  }
  removeEvent(e, t) {
    return this.events[e] ? (this.events[e] = this.events[e].filter((i) => i !== t), this) : this;
  }
  async triggerEvent(e, ...t) {
    return this.events[e] ? Promise.all(this.events[e].map((i) => Promise.resolve(i(...t)))).then(() => this) : this;
  }
  getPrice() {
    return this.priceManager.last_calculated_price;
  }
  setOtherPriceTagElement(e) {
    this.priceManager.setOtherPriceTagElement(e);
  }
}
const Vt = `
<svg aria-hidden="true" focusable="false" fill="none" width="14" class="icon icon-close" viewBox="0 0 16 16">
      <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"></path>
    </svg>
`;
function et(s, e = Je() ? 100 : 200) {
  const t = s.getBoundingClientRect().top + window.scrollY - e;
  window.scrollTo({ behavior: "smooth", top: t });
}
const Ht = {
  sections: [
    {
      items: [
        {
          type: "engraving",
          title: "Option 1",
          help_text: "",
          id: 6717748,
          rules: [],
          required: !1,
          config: {
            sections: [
              {
                canvas: {
                  width: 882,
                  height: 1113
                },
                img: "https://cdn.shopify.com/s/files/1/0908/0697/6894/files/snowboard_purple_hydrogen.png?v=1739961707",
                fields: [
                  {
                    allowEmoji: !1,
                    canvas: {
                      height: 142.5,
                      left: 237.75,
                      top: 813.25,
                      width: 166.5
                    },
                    defaultValue: "",
                    fontSize: 15,
                    fonts: [],
                    help_text: "",
                    maxFontSize: 20,
                    minFontSize: 10,
                    title: "",
                    type: "text",
                    validation: {
                      maxLength: 60,
                      maxLineLength: 10,
                      maxLines: 3,
                      maxWordsPerLine: 1,
                      minLength: 8,
                      required: !1
                    },
                    showAdvancedOptions: !0,
                    alignment: "center",
                    color: "#b84747"
                  }
                ],
                title: "dededdededed"
              },
              {
                canvas: {
                  width: 882,
                  height: 882
                },
                img: "https://cdn.shopify.com/s/files/1/0908/0697/6894/files/Main_0a4e9096-021a-4c1e-8750-24b233166a12.jpg?v=1739961706",
                fields: [
                  {
                    allowEmoji: !1,
                    canvas: {
                      height: 294.5,
                      left: 274.75,
                      top: 285.75,
                      width: 128.5
                    },
                    defaultValue: "",
                    fontSize: 15,
                    fonts: [],
                    help_text: "this this an example help text",
                    maxFontSize: 20,
                    minFontSize: 10,
                    title: "this is a the title of the control",
                    type: "text",
                    alignment: "center",
                    position: "center",
                    validation: {
                      maxLength: 60,
                      maxLineLength: 20,
                      maxLines: 3,
                      maxWordsPerLine: 3,
                      minLength: 0,
                      required: !1
                    }
                  }
                ],
                title: "dedded"
              }
            ]
          }
        },
        {
          type: "engraving",
          title: "Here is the engraving title",
          help_text: "Here is the engraving help text.",
          id: 7561544,
          rules: [],
          required: !0,
          config: {
            sections: [
              {
                canvas: {
                  width: 882,
                  height: 1108
                },
                img: "https://cdn.shopify.com/s/files/1/0908/0697/6894/files/image_7.png?v=1742471617",
                fields: [
                  {
                    canvas: {
                      height: 466.5,
                      left: 201.75,
                      top: 544.75,
                      width: 466.5
                    },
                    cropSettings: {},
                    help_text: "You can skip this section as this is not required",
                    is_rounded: !0,
                    title: "Please select an image.",
                    type: "image",
                    validation: {
                      allowedTypes: [],
                      maxFileSize: 0,
                      required: !1
                    }
                  }
                ],
                title: "Front of engraving"
              },
              {
                canvas: {
                  width: 882,
                  height: 1108
                },
                img: "https://cdn.shopify.com/s/files/1/0908/0697/6894/files/image_7_02784429-c356-4ad9-abb1-3117341028a2.png?v=1742472938",
                fields: [
                  {
                    allowEmoji: !1,
                    canvas: {
                      height: 133.5,
                      left: 362.75,
                      top: 567.75,
                      width: 147.5
                    },
                    defaultValue: "",
                    fontSize: 100,
                    fonts: [],
                    help_text: "this initial is required",
                    maxFontSize: 100,
                    minFontSize: 100,
                    title: "Initial one",
                    type: "text",
                    alignment: "center",
                    position: "top",
                    validation: {
                      maxLength: 1,
                      maxLineLength: 20,
                      maxLines: 3,
                      maxWordsPerLine: 3,
                      minLength: 0,
                      required: !0
                    },
                    placeholder: "A",
                    showAdvancedOptions: !0,
                    color: "#b96a6a",
                    singleLine: !0
                  },
                  {
                    allowEmoji: !1,
                    canvas: {
                      height: 147.6692307692308,
                      left: 529.2576923076923,
                      top: 689.6423076923077,
                      width: 128.5
                    },
                    defaultValue: "",
                    fontSize: 100,
                    fonts: [],
                    help_text: "this initial is required",
                    maxFontSize: 100,
                    minFontSize: 100,
                    title: "initial two",
                    type: "text",
                    alignment: "center",
                    position: "center",
                    validation: {
                      maxLength: 1,
                      maxLineLength: 20,
                      maxLines: 3,
                      maxWordsPerLine: 3,
                      minLength: 0,
                      required: !0
                    },
                    placeholder: "B",
                    showAdvancedOptions: !0,
                    color: "#c62a2a",
                    singleLine: !0
                  },
                  {
                    allowEmoji: !1,
                    canvas: {
                      height: 139.5,
                      left: 366.28846153846155,
                      top: 824.6423076923077,
                      width: 148.5
                    },
                    defaultValue: "",
                    fontSize: 100,
                    fonts: [],
                    help_text: "this initial is required",
                    maxFontSize: 100,
                    minFontSize: 100,
                    title: "intial three",
                    type: "text",
                    alignment: "center",
                    position: "center",
                    validation: {
                      maxLength: 1,
                      maxLineLength: 20,
                      maxLines: 3,
                      maxWordsPerLine: 3,
                      minLength: 0,
                      required: !0
                    },
                    placeholder: "C",
                    showAdvancedOptions: !0,
                    color: "#8236b5",
                    singleLine: !0
                  },
                  {
                    allowEmoji: !1,
                    canvas: {
                      height: 136.06923076923067,
                      left: 219.18076923076916,
                      top: 689.5038461538464,
                      width: 119.48461538461527
                    },
                    defaultValue: "",
                    fontSize: 100,
                    fonts: [],
                    help_text: "this initial is required",
                    maxFontSize: 100,
                    minFontSize: 100,
                    title: "intial four",
                    type: "text",
                    alignment: "center",
                    position: "center",
                    validation: {
                      maxLength: 1,
                      maxLineLength: 20,
                      maxLines: 3,
                      maxWordsPerLine: 3,
                      minLength: 0,
                      required: !0
                    },
                    placeholder: "D",
                    showAdvancedOptions: !0,
                    color: "#f0a70a",
                    singleLine: !0
                  }
                ],
                title: "Write initials"
              }
            ],
            buttonText: "Your free engraving"
          }
        },
        {
          type: "finger_print",
          title: "Option 5",
          help_text: "this is the help text?",
          id: 4594936,
          rules: [],
          required: !0,
          config: {
            sections: []
          },
          cart_button_help_text: "test help button",
          upload_title: "Uploads",
          upload_text: "Please upload your fingerprint image if you already have one.s",
          upload_button: "Uploads",
          previous_order_title: "Use Print From Previous Orders",
          previous_order_text: "Enter order numbers"
        },
        // {
        //     "type": "wrapping",
        //     "title": "Option 1",
        //     "help_text": "",
        //     "id": 3994988,
        //     "rules": [],
        //     "required": true,
        //     "config": {
        //         "sections": []
        //     },
        //     "options": [
        //         {
        //             "options": [
        //                 {
        //                     "options": [
        //                         "1",
        //                         "2",
        //                         "3",
        //                         "4",
        //                         "5"
        //                     ],
        //                     "id": "gid://shopify/ProductVariant/56672273170814",
        //                     "parent_id": "gid://shopify/Product/15703964352894",
        //                     "title": "test child option woohoo",
        //                     "help_text": "pleaassee god",
        //                     "placeholder": "",
        //                     "price_addon": "30.00",
        //                     "stock": 10,
        //                     "type": "select",
        //                     "thumbnail_image": "",
        //                     "field_instruction": "this is it"
        //                 }
        //             ],
        //             "id": "gid://shopify/ProductVariant/56672184402302",
        //             "parent_id": "gid://shopify/Product/15703922082174",
        //             "title": "wet again",
        //             "help_text": "",
        //             "placeholder": "",
        //             "price_addon": "30.00",
        //             "stock": 10,
        //             "type": "text",
        //             "thumbnail_image": "https://cdn.shopify.com/s/files/1/0908/0697/6894/files/theme_cover_image.jpg?v=1739961706",
        //             "field_instruction": ""
        //         }
        //     ],
        //     "description": "this is the description",
        //     "add_to_cart_button": "this is the open cart button",
        //     "add_to_basket_text": "this is the gift wrapping",
        //     "add_to_basket_without_wrapping_text": "this is the skip giftwrapping"
        // },
        // {
        //     "type": "wrapping",
        //     "title": "Luxury Gift Wrap",
        //     "required": false,
        //     "add_to_cart_button": "Add to bag with personalisation",
        //     "add_to_basket_text": "add_to_basket_text",
        //     "add_to_basket_without_wrapping_text": "add_to_basket_without_wrapping_text",
        //     "description": "Make your gift extra special with our luxury packaging options. Select a gift bag, gift box or a combination to create the perfect presentation.\n" +
        //         "\n" +
        //         "Each selection can be personalised after you choose it.",
        //     "options": [
        //         {
        //             "title": "Gift Bag (White)",
        //             "price_addon": "120.00",
        //             "stock": 10,
        //             "product_image": "",
        //             "thumbnail_image": "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/balloon-treats--shadow.webp?v=1755723663",
        //             "id": "gid://shopify/ProductVariant/51210092740955",
        //             "options": [
        //                 {
        //                     "id": "gid://shopify/ProductVariant/51210092740955",
        //                     "title": "Add a personalised message.",
        //                     "help_text": "Add a personalised message.",
        //                     "placeholder": "Add a personalised message.",
        //                     "price_addon": "20.00",
        //                     "stock": 10,
        //                     "type": "text",
        //                     "field_instruction": "do this, do that"
        //                 },
        //                 {
        //                     "id": "gid://shopify/ProductVariant/51210092740955",
        //                     "title": "Select a select option",
        //                     "help_text": "Select a select option",
        //                     "placeholder": "Select a select option",
        //                     "price_addon": "20",
        //                     "stock": 10,
        //                     "type": "select",
        //                     "options": ["A", "B", "C", "D"],
        //                     "field_instruction": "do this, do that"
        //                 }
        //             ]
        //         },
        //         {
        //             "title": "Gift Bag (White)",
        //             "price_addon": "120.00",
        //             "stock": 10,
        //             "product_image": "",
        //             "thumbnail_image": "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/balloon-treats--shadow.webp?v=1755723663",
        //             "id": "gid://shopify/ProductVariant/51210092740955",
        //             "options": [
        //                 {
        //                     "title": "Add a personalised message.",
        //                     "help_text": "Add a personalised message.",
        //                     "placeholder": "Add a personalised message.",
        //                     "price_addon": "20.00",
        //                     "stock": 10,
        //                     "type": "text"
        //                 },
        //                 {
        //                     "title": "Select a select option",
        //                     "help_text": "Select a select option",
        //                     "placeholder": "Select a select option",
        //                     "price_addon": "20",
        //                     "stock": 10,
        //                     "type": "select",
        //                     "options": ["A", "B", "C", "D"]
        //                 }
        //             ]
        //         }
        //     ]
        // },
        {
          type: "variant",
          title: "Option 1",
          help_text: "",
          id: 4564890,
          rules: [],
          required: !0,
          config: {
            id: "10060127830363",
            title: "Balloon Letters",
            help_text: "",
            options: [
              {
                title: "The Mini Balloon Letter Necklace",
                price_addon: "120.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/balloon-treats--shadow.webp?v=1755723663",
                id: "gid://shopify/ProductVariant/51210092740955"
              },
              {
                title: "A",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_A.png?v=1755721931",
                id: "gid://shopify/ProductVariant/51210054959451"
              },
              {
                title: "B",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_B.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210065772891"
              },
              {
                title: "C",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_C.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210065805659"
              },
              {
                title: "D",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_D.png?v=1755722006",
                id: "gid://shopify/ProductVariant/51210065838427"
              },
              {
                title: "E",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_E.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210065871195"
              },
              {
                title: "F",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_F.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210065903963"
              },
              {
                title: "G",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_G.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210065936731"
              },
              {
                title: "H",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_H.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210065969499"
              },
              {
                title: "I",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_I.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066002267"
              },
              {
                title: "J",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_J.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066035035"
              },
              {
                title: "K",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_K.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066067803"
              },
              {
                title: "L",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_L.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066100571"
              },
              {
                title: "M",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_M.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066133339"
              },
              {
                title: "N",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_N.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066166107"
              },
              {
                title: "O",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_O.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066198875"
              },
              {
                title: "P",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_P.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066231643"
              },
              {
                title: "Q",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_Q.png?v=1755722006",
                id: "gid://shopify/ProductVariant/51210066264411"
              },
              {
                title: "R",
                price_addon: "0.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_R.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066297179"
              },
              {
                title: "S",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_S.png?v=1755722006",
                id: "gid://shopify/ProductVariant/51210066329947"
              },
              {
                title: "T",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_T.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066362715"
              },
              {
                title: "U",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_U.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066395483"
              },
              {
                title: "V",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_V.png?v=1755722006",
                id: "gid://shopify/ProductVariant/51210066428251"
              },
              {
                title: "W",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_W.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066461019"
              },
              {
                title: "X",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_X.png?v=1755722006",
                id: "gid://shopify/ProductVariant/51210066493787"
              },
              {
                title: "Y",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_Y.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066526555"
              },
              {
                title: "Z",
                price_addon: "10.00",
                stock: 10,
                product_image: "",
                thumbnail_image: "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/Treats_MiniBalloon_Z.png?v=1755722005",
                id: "gid://shopify/ProductVariant/51210066559323"
              }
            ],
            manage_stock: !0,
            type: "dropdown"
          },
          variant_id: "10060127830363",
          // "layout": "charm-builder",
          first_item_is_addon_row: !0,
          add_charm_button: "Add necklace",
          list_item_title: "personalised necklace"
        }
        // {
        //     "type": "variant",
        //     "title": "Metal",
        //     "help_text": "",
        //     "id": 1985875,
        //     "layout": "charm-builder",
        //     "rules": [],
        //     "required": true,
        //     "charm_addon": {
        //       "title": "The Mini Balloon Letter Necklace",
        //       "price_addon": 15,
        //       "stock": 100,
        //       "product_image": "https://www.treatsstudio.co.uk/cdn/shop/files/balloon-treats--shadow.jpg?v=1728550104",
        //       "thumbnail_image": "https://www.treatsstudio.co.uk/cdn/shop/files/balloon-treats--shadow.jpg?v=1728550104",
        //       "id": "Main A"
        //     },
        //     "add_charm_button": "Add necklace",
        //     "list_item_title": "personalised necklace",
        //     "config": {
        //         "id": "9914932822363",
        //         "title": "Balloon Letters",
        //         "help_text": "",
        //         "options":[
        //             {
        //                 "title": "A",
        //                 "price_addon": 0,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_A.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_A.png?v=1700505055",
        //                 "id": "test_A"
        //             },
        //             {
        //                 "title": "B",
        //                 "price_addon": 5,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_B.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_B.png?v=1700505055",
        //                 "id": "test_B"
        //             },
        //             {
        //                 "title": "C",
        //                 "price_addon": 10,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_C.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_C.png?v=1700505055",
        //                 "id": "test_C"
        //             },
        //             {
        //                 "title": "D",
        //                 "price_addon": 15,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_D.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_D.png?v=1700505055",
        //                 "id": "test_D"
        //             },
        //             {
        //                 "title": "E",
        //                 "price_addon": 20,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_E.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_E.png?v=1700505055",
        //                 "id": "test_E"
        //             },
        //             {
        //                 "title": "F",
        //                 "price_addon": 25,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_F.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_F.png?v=1700505055",
        //                 "id": "test_F"
        //             },
        //             {
        //                 "title": "G",
        //                 "price_addon": 30,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_G.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_G.png?v=1700505055",
        //                 "id": "test_G"
        //             },
        //             {
        //                 "title": "H",
        //                 "price_addon": 35,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_H.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_H.png?v=1700505055",
        //                 "id": "test_H"
        //             },
        //             {
        //                 "title": "I",
        //                 "price_addon": 40,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_I.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_I.png?v=1700505055",
        //                 "id": "test_I"
        //             },
        //             {
        //                 "title": "J",
        //                 "price_addon": 45,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_J.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_J.png?v=1700505055",
        //                 "id": "test_J"
        //             },
        //             {
        //                 "title": "K",
        //                 "price_addon": 50,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_K.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_K.png?v=1700505055",
        //                 "id": "test_K"
        //             },
        //             {
        //                 "title": "L",
        //                 "price_addon": 55,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_L.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_L.png?v=1700505055",
        //                 "id": "test_L"
        //             },
        //             {
        //                 "title": "M",
        //                 "price_addon": 60,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_M.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_M.png?v=1700505055",
        //                 "id": "test_M"
        //             },
        //             {
        //                 "title": "N",
        //                 "price_addon": 65,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_N.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_N.png?v=1700505055",
        //                 "id": "test_N"
        //             },
        //             {
        //                 "title": "O",
        //                 "price_addon": 70,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_O.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_O.png?v=1700505055",
        //                 "id": "test_O"
        //             },
        //             {
        //                 "title": "P",
        //                 "price_addon": 75,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_P.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_P.png?v=1700505055",
        //                 "id": "test_P"
        //             },
        //             {
        //                 "title": "Q",
        //                 "price_addon": 80,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_Q.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_Q.png?v=1700505055",
        //                 "id": "test_Q"
        //             },
        //             {
        //                 "title": "R",
        //                 "price_addon": 85,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_R.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_R.png?v=1700505055",
        //                 "id": "test_R"
        //             },
        //             {
        //                 "title": "S",
        //                 "price_addon": 90,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_S.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_S.png?v=1700505055",
        //                 "id": "test_S"
        //             },
        //             {
        //                 "title": "T",
        //                 "price_addon": 95,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_T.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_T.png?v=1700505055",
        //                 "id": "test_T"
        //             },
        //             {
        //                 "title": "U",
        //                 "price_addon": 100,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_U.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_U.png?v=1700505055",
        //                 "id": "test_U"
        //             },
        //             {
        //                 "title": "V",
        //                 "price_addon": 105,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_V.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_V.png?v=1700505055",
        //                 "id": "test_V"
        //             },
        //             {
        //                 "title": "W",
        //                 "price_addon": 110,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_W.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_W.png?v=1700505055",
        //                 "id": "test_W"
        //             },
        //             {
        //                 "title": "X",
        //                 "price_addon": 115,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_X.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_X.png?v=1700505055",
        //                 "id": "test_X"
        //             },
        //             {
        //                 "title": "Y",
        //                 "price_addon": 120,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_Y.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_Y.png?v=1700505055",
        //                 "id": "test_Y"
        //             },
        //             {
        //                 "title": "Z",
        //                 "price_addon": 125,
        //                 "stock": 100,
        //                 "product_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_Z.png?v=1700505055",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0666/6744/6590/files/Treats_MiniBalloon_Z.png?v=1700505055",
        //                 "id": "test_Z"
        //             }
        //         ],
        //         "manage_stock": true,
        //         "type": "dropdown"
        //     },
        //     "variant_id": "9914932822363"
        // },
        // {
        //     "type": "variant",
        //     "title": "Metal",
        //     "help_text": "",
        //     "id": 1985875,
        //     "layout": "list",
        //     "rules": [],
        //     "required": true,
        //     "config": {
        //         "id": "9914932822363",
        //         "title": "Metal",
        //         "help_text": "",
        //         "options": [
        //             {
        //                 "title": "Gold Vermeil",
        //                 "price_addon": "5.00",
        //                 "stock": 10,
        //                 "product_image": "",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/image.jpg?v=1747909288",
        //                 "id": "gid://shopify/ProductVariant/50622342889819"
        //             },
        //             {
        //                 "title": "Solid Gold",
        //                 "price_addon": "100.00",
        //                 "stock": 10,
        //                 "product_image": "",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/image.png?v=1747909321",
        //                 "id": "gid://shopify/ProductVariant/50622343184731"
        //             }
        //         ],
        //         "manage_stock": true,
        //         "type": "dropdown"
        //     },
        //     "variant_id": "9914932822363"
        // },
        // {
        //     "type": "multi-select",
        //     "title": "1 Initial",
        //     "help_text": "",
        //     "id": 3545720,
        //     "rules": [],
        //     "required": true,
        //     "config": {
        //         "sections": []
        //     },
        //     "options": [
        //         {
        //             "title": "Position 1",
        //             "options": [
        //                 {
        //                     "title": "Letters",
        //                     "options": [
        //                         "a",
        //                         "b",
        //                         "c",
        //                         "d",
        //                         "e",
        //                         "f",
        //                         "g"
        //                     ]
        //                 }
        //             ]
        //         },
        //         {
        //             "title": "Position 2",
        //             "options": [
        //                 {
        //                     "title": "Letters",
        //                     "options": [
        //                         "a",
        //                         "b",
        //                         "c",
        //                         "d",
        //                         "e",
        //                         "f",
        //                         "g"
        //                     ]
        //                 }
        //             ]
        //         },
        //         {
        //             "title": "Position 3",
        //             "options": [
        //                 {
        //                     "title": "Letters",
        //                     "options": [
        //                         "a",
        //                         "b",
        //                         "c",
        //                         "d",
        //                         "e",
        //                         "f",
        //                         "g"
        //                     ]
        //                 }
        //             ]
        //         }
        //     ]
        // },
        // {
        //     "type": "variant",
        //     "title": "Metal",
        //     "help_text": "",
        //     "id": 1985875,
        //     "rules": [],
        //     "required": true,
        //     "config": {
        //         "id": "9914932822363",
        //         "title": "Metal",
        //         "help_text": "",
        //         "options": [
        //             {
        //                 "title": "Gold Vermeil",
        //                 "price_addon": "5.00",
        //                 "stock": 10,
        //                 "product_image": "",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/image.jpg?v=1747909288",
        //                 "id": "gid://shopify/ProductVariant/50622342889819"
        //             },
        //             {
        //                 "title": "Solid Gold",
        //                 "price_addon": "100.00",
        //                 "stock": 10,
        //                 "product_image": "",
        //                 "thumbnail_image": "https://cdn.shopify.com/s/files/1/0930/3090/8251/files/image.png?v=1747909321",
        //                 "id": "gid://shopify/ProductVariant/50622343184731"
        //             }
        //         ],
        //         "manage_stock": true,
        //         "type": "dropdown"
        //     },
        //     "variant_id": "9914932822363"
        // },
        // {
        //     "type": "variant",
        //     "title": "Chain Length",
        //     "help_text": "",
        //     "id": 9499830,
        //     "rules": [],
        //     "required": true,
        //     "config": {
        //         "id": "9914951991643",
        //         "title": "Chain Length",
        //         "help_text": "",
        //         "options": [
        //             {
        //                 "title": "16cm",
        //                 "price_addon": "0.00",
        //                 "stock": 10,
        //                 "product_image": "",
        //                 "thumbnail_image": "",
        //                 "id": "gid://shopify/ProductVariant/50622369431899"
        //             },
        //             {
        //                 "title": "18cm",
        //                 "price_addon": "0.00",
        //                 "stock": 10,
        //                 "product_image": "",
        //                 "thumbnail_image": "",
        //                 "id": "gid://shopify/ProductVariant/50622369726811"
        //             },
        //             {
        //                 "title": "20cm",
        //                 "price_addon": "0.00",
        //                 "stock": 10,
        //                 "product_image": "",
        //                 "thumbnail_image": "",
        //                 "id": "gid://shopify/ProductVariant/50622369759579"
        //             }
        //         ],
        //         "manage_stock": true,
        //         "type": "checkbox"
        //     },
        //     "variant_id": "9914951991643"
        // }
      ]
    }
    // {
    //     "items": [
    //         {
    //             "type": "multi-select",
    //             "title": "2 Initials",
    //             "help_text": "",
    //             "id": 1593641,
    //             "rules": [],
    //             "required": true,
    //             "config": {
    //                 "sections": []
    //             },
    //             "options": [
    //                 {
    //                     "title": "2 Initials",
    //                     "options": [
    //                         {
    //                             "title": "Position 1",
    //                             "options": [
    //                                 "a",
    //                                 "b",
    //                                 "c",
    //                                 "d",
    //                                 "e",
    //                                 "f",
    //                                 "g"
    //                             ]
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     "title": "2 Initials",
    //                     "options": [
    //                         {
    //                             "title": "Position 2",
    //                             "options": [
    //                                 "a",
    //                                 "b",
    //                                 "c",
    //                                 "d",
    //                                 "e",
    //                                 "f",
    //                                 "g"
    //                             ]
    //                         }
    //             ]
    //                     ]
    //                 }
    //         }
    //     ]
    // }
  ],
  im_here: !0
}, tt = "https://www.taylr.co.uk/apps/custom-options/", Rt = tt, zt = new URL(window.location.href).origin + "/cart.js", qt = new URL(window.location.href).origin + "/cart/clear.js", Wt = new URL(window.location.href).origin + "/cart/add.js";
window.addEventListener("DOMContentLoaded", function() {
  Ut(), je(), Ue();
  const s = l("#variant-custom-options"), e = window.location.hostname === "localhost";
  if (s) {
    const t = () => Math.round(Math.random() * 1e7);
    (async () => {
      if (e)
        return {
          product_id: "14956731662718",
          parent: {
            price: 118600
          },
          product: Ht
        };
      const n = new URL(window.location.href).origin + new URL(window.location.href).pathname;
      return fetch(n + ".js").then((a) => a.json()).then((a) => {
        const o = a.id, p = a.variants?.[0]?.id || o, h = a, m = new URL(window.location.href).searchParams.get("variant"), g = m && a.variants.find((w) => w.id.toString() === m) || a.variants[0];
        return fetch(tt + "info/product/" + o).then((w) => w.json()).then((w) => (w.product_id = p, w.parent = h, w.price = g?.price || h.price, w.available = g.available || !1, w)).catch(() => ({
          product_id: p,
          product: !1,
          parent: h,
          price: g?.price || h.price,
          available: g.available || !1
        }));
      }).catch(() => ({ product_id: 0, product: !1 }));
    })().then(({ product_id: n, product: a, parent: o, price: p, available: h }) => {
      const m = new Dt();
      m.setTarget(s), m.setPrice(p / 100), m.parseConfiguration(a || {}), m.render(), m.setIfInStock(h), m.setOtherPriceTagElement(
        () => document.querySelector(".product__price .price__regular span:not(.visually-hidden)")
      ), m.addEvent("onAddToCart", () => {
        const T = t(), g = {
          id: n,
          quantity: 1,
          properties: {
            _total_price: m.getPrice() * 100,
            _product_id: T
          }
        }, w = [g], v = m.getAllValidCartOptions();
        let P = !1;
        Promise.all(v.map(async (x, F) => {
          let W = x.getValue()[0];
          if (x.config?.type === "variant")
            if (x.config.layout === "charm-builder") {
              P = !0;
              const D = x, H = x.getValue();
              for (const Y of H)
                w.push({
                  id: (Y.option.id + "").split("/").pop(),
                  quantity: 1,
                  image: Y.option.product_image || Y.option.thumbnail_image,
                  properties: {
                    _product_id: T,
                    _is_variant: !0
                  }
                });
              const A = x.config.config.title;
              g.properties["_charmImages:" + x.config.title + " - " + A] = D.buildSelectionImage(), D.config.charm_addon && (g.properties[x.config.title + " - " + D.config.add_charm_button] = D.mainAddonIsInSelectionList() ? "Yes" : "No");
            } else
              (W.price_addon && parseInt(W.price_addon) > 0 || x.config?.config?.manage_stock) && w.push({
                id: (W.id + "").split("/").pop(),
                quantity: 1,
                image: W.product_image || W.thumbnail_image,
                properties: {
                  _product_id: T,
                  _is_variant: !0
                }
              }), W = W.title;
          if (x.config?.type === "engraving") {
            const D = x.getValue()?.[0];
            if (!D) return Promise.resolve();
            const H = D?.sectionImages || [];
            if (await Promise.all(H.map(async (A, Y) => {
              const G = await qe(A);
              return G?.url && (g.properties["" + x.config.config.sections[Y].title] = G?.url), G.url;
            })), D?.fields.length)
              for (const A of D.fields) {
                const Y = x.config.config.sections[A.section].fields[A.key];
                if (Y?.type === "text" && (g.properties[Y.title + ""] = A.value.text), Y?.type === "image")
                  try {
                    g.properties["_" + x.config.title + "_image"] = await qe(A.value.imageData).then((G) => G?.url);
                  } catch {
                  }
              }
          }
          if (x.config?.type === "multi-select") {
            const D = x.getValue();
            if (D.length)
              for (const [H, A] of Object.entries(x.config.options))
                g.properties[A.title] = D[+H] || "-";
          }
          if (x.config?.type === "image" && (W = (await qe(W)).url), x.config?.type !== "engraving" && x.config?.layout !== "charm-builder" && x.config?.type !== "wrapping" && (g.properties[x.config.title] = W), x.config?.type === "wrapping") {
            const D = x.getValue();
            for (const H of D) {
              const A = {
                id: H.id.replace(/\D/g, ""),
                quantity: 1,
                properties: {
                  _product_id: T
                }
              };
              H.type === "select" && (A.properties.selected = H.value || ""), H.type === "text" && (A.properties.text = H.value || ""), w.push(A);
            }
          }
          P && +o.price;
        })).then(() => Ye(w));
      }), Nt(m);
    });
  }
});
function Nt(s) {
  PUB_SUB_EVENTS && subscribe && subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
    const t = e?.data?.variant;
    t && setTimeout(() => {
      s.setPrice(t.price / 100), s.setIfInStock(t.available), s.render();
    }, 1);
  });
}
async function qe(s) {
  if (s) {
    const e = s?.match(/data:(image\/..*);/)?.[1] || "image/jpg", t = new FormData();
    return t.append("file", jt(s, e)), fetch(Rt + "user/image", {
      method: "POST",
      body: t
    }).then((i) => i.json()).catch((i) => console.error(i));
  }
  return Promise.reject("No file provided");
}
const jt = (s, e = "", t = 512) => {
  s = s.replace(/^data:image\/[^;]+;base64,/, "");
  const i = atob(s), n = [];
  for (let o = 0; o < i.length; o += t) {
    const p = i.slice(o, o + t), h = new Array(p.length);
    for (let T = 0; T < p.length; T++)
      h[T] = p.charCodeAt(T);
    const m = new Uint8Array(h);
    n.push(m);
  }
  return new Blob(n, { type: e });
};
function Ut() {
  const s = document.querySelectorAll(".update-button-trigger");
  for (const e of s) {
    const t = e.dataset.productId;
    t && e.addEventListener("click", function(i) {
      i.preventDefault(), i.stopPropagation(), Le().then((n) => {
        const a = n.items.filter((o) => o?.properties?._product_id !== +t);
        it().then(() => {
          a.length ? Ye(a).then(() => setTimeout(() => window.location.reload(), 500)) : window.location.reload();
        });
      });
    });
  }
}
async function Le() {
  return fetch(zt).then((s) => s.json()).then((s) => s);
}
async function it() {
  return fetch(qt, { method: "POST" }).then((s) => s.json()).then((s) => s);
}
function Yt(s) {
  const e = s.items.filter((i) => !i?.properties._is_variant).reduce((i, n) => i + n.quantity, 0);
  [
    ".cart__title-counter",
    ".cart-drawer__title-counter",
    ".cart-count-badge"
  ].forEach((i) => {
    const n = document.querySelector(i);
    n && (n.innerHTML = e);
  });
}
function je() {
  for (const s of document.querySelectorAll("cart-drawer-items, cart-items"))
    s.updateQuantity = Xt.bind(s);
}
function Xt(s, e, t) {
  this.classList.add("is-loading"), Le().then((i) => {
    const n = i.items[s - 1].properties._product_id, a = e === 0, o = [];
    for (const h of i.items)
      if (h.properties._product_id !== n)
        o.push(h);
      else if (!a) {
        if (typeof h.properties._total_price < "u") {
          const m = h.properties._total_price / h.quantity;
          h.properties._total_price = m * e;
        }
        h.quantity = e, o.push(h);
      }
    const p = (h) => new Promise((m) => {
      this.getSectionsToRender()?.forEach((g) => {
        const w = document.querySelector(g.selector) || document.querySelector(g.id);
        w ? h.errors || (w.innerHTML = this.getSectionInnerHTML(
          h.sections[g.section],
          g.selector
        )) : console.error(`Element with selector ${g.selector} not found`);
      }), h.errors || (this.totalItemCount = this.calculateTotalItemCount(h.items)), this.updateLiveRegions(s, h.item_count, h.errors);
      const T = document.getElementById(`CartItem-${s}`);
      T && T.querySelector(`[name="${t}"]`) && T.querySelector(`[name="${t}"]`).focus(), updateCartCounters(), updateFreeShipping(), m(!0);
    }).then(Ue).finally(() => this.classList.remove("is-loading")).finally(je);
    it().then(() => {
      o.length ? Ye(o, !1).then(async () => await new Promise((h) => setTimeout(h, 1e3))).then(Kt).then(p) : Gt().then(p);
    });
  });
}
function nt() {
  return fetch(window.Shopify.routes.root + "?sections=" + document.querySelector("cart-drawer").getSectionsToRender().map((s) => s.section).join(",")).then((s) => s.json());
}
async function Jt() {
  return new Promise(async (t) => {
    let i;
    for (let n = 0; n < 20 && (i = await Le(), !i.items.length); n++)
      await new Promise((a) => setTimeout(a, 150));
    t(i);
  });
}
function Gt() {
  return Promise.all([nt(), Le()]).then(([s, e]) => ({ sections: s, ...e }));
}
function Kt() {
  return Promise.all([nt(), Jt()]).then(([s, e]) => ({ sections: s, ...e }));
}
function Ue() {
  Le().then(Yt);
}
function Qt(s) {
  const e = document.querySelector("cart-drawer");
  e && typeof e.renderContents == "function" ? (e.renderContents(s), Ue(), je()) : window.location.href = "/cart";
}
async function Ye(s, e = !0) {
  fetch(Wt, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: s.reverse(),
      sections: document.querySelector("cart-drawer").getSectionsToRender().map((t) => t.section),
      sections_url: window.location.pathname
    })
  }).then((t) => t.json()).then((t) => e ? Qt(t) : !0).catch((t) => console.error(t));
}
